import { useEffect, useMemo, useRef, useState } from 'react'
import {
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowUp,
  BadgeCheck,
  Bike,
  CarFront,
  Check,
  ChevronDown,
  Clock3,
  ExternalLink,
  Headphones,
  Languages,
  LoaderCircle,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  Phone,
  Search,
  Send,
  SendHorizontal,
  ShieldCheck,
  Tractor,
  X,
} from 'lucide-react'

const vehicleFields = [
  ['description', 'Описание техники'],
  ['registrationNumber', 'REG номер'],
  ['vin', 'VIN'],
  ['make', 'Марка'],
  ['model', 'Модель'],
  ['year', 'Год'],
  ['firstRegistration', 'Первая регистрация'],
  ['category', 'Категория'],
  ['bodyType', 'Тип кузова'],
  ['color', 'Цвет'],
  ['fuel', 'Топливо'],
  ['engineCapacityCc', 'Объём двигателя', ' см³'],
  ['powerKw', 'Мощность', ' кВт'],
  ['transmission', 'Коробка передач'],
  ['driveType', 'Привод'],
  ['curbWeightKg', 'Снаряжённая масса', ' кг'],
  ['grossWeightKg', 'Полная масса', ' кг'],
  ['seats', 'Количество мест'],
  ['doors', 'Количество дверей'],
  ['status', 'Статус в регистре'],
  ['inspectionValidUntil', 'Техосмотр до'],
  ['co2GKm', 'CO₂', ' г/км'],
  ['mileageKm', 'Пробег', ' км'],
  ['country', 'Страна производства'],
]

const companyDetails = {
  name: 'Osaühing SVENTLI AUTO',
  registryCode: '11002829',
  address: 'Rakvere tn 19, Jõhvi linn, Jõhvi vald, Ida-Viru maakond, 41533, Eesti',
  registryUrl: 'https://ariregister.rik.ee/est/company/11002829/Osa%C3%BChing-SVENTLI-AUTO',
}

const translations = {
  en: {
    'Открыть чат': 'Open chat',
    'Закрыть чат': 'Close chat',
    'Напишите нам': 'Write to us',
    'Чат с CarCash': 'Chat with CarCash',
    'Напишите нам — ответ появится здесь.': 'Send us a message — the reply will appear here.',
    'Обычно отвечаем в рабочее время': 'We usually reply during business hours',
    'E-mail или телефон': 'E-mail or phone',
    'Ваше сообщение': 'Your message',
    'Напишите сообщение…': 'Write a message…',
    'Отправить сообщение': 'Send message',
    'Не удалось отправить сообщение. Попробуйте ещё раз.': 'Could not send the message. Please try again.',
    'Чат временно недоступен.': 'Chat is temporarily unavailable.',
    'Диалог завершён': 'Conversation closed',
    'Этот диалог был закрыт. Если хотите продолжить, начните новый.': 'This conversation has been closed. Start a new one if you would like to continue.',
    'Начать новый диалог': 'Start a new conversation',
    'Вы': 'You',
    'Команда CarCash': 'CarCash team',
    'Отправляя сообщение, вы соглашаетесь с обработкой данных согласно': 'By sending a message, you agree to data processing under our',
    'политике конфиденциальности': 'privacy policy',
    'CarCash — на главную': 'CarCash — home',
    'Основная навигация': 'Main navigation',
    'Язык интерфейса': 'Interface language',
    'Что покупаем': 'What we buy',
    'Как это работает': 'How it works',
    'Вопросы': 'Questions',
    'Позвонить нам': 'Call us',
    'Оценить технику': 'Value your vehicle',
    'Закрыть меню': 'Close menu',
    'Открыть меню': 'Open menu',
    'Перейти к содержанию': 'Skip to content',
    'ВЫКУП ТЕХНИКИ · ЭСТОНИЯ': 'VEHICLE ACQUISITION · ESTONIA',
    'Точная оценка.': 'Accurate valuation.',
    'Честная сделка.': 'A fair deal.',
    'Автомобили, коммерческий транспорт и специальная техника. Найдите объект по REG или VIN и получите персональное предложение.': 'Cars, commercial vehicles and specialist equipment. Search by REG or VIN, or add the vehicle manually, and receive a personal offer.',
    'Бюджет на выкуп не ограничен': 'No fixed acquisition budget',
    'Автомобиль, грузовик, экскаватор, мотоцикл и катер, которые покупает CarCash': 'Car, truck, excavator, motorcycle and boat purchased by CarCash',
    'ПРОВЕРКА ТЕХНИКИ': 'VEHICLE CHECK',
    'Найдём данные за минуту': 'Find the details in a minute',
    'REG, VIN или описание — выберите удобный способ идентификации.': 'REG, VIN or a description — choose the most convenient way to identify it.',
    'Данные защищены': 'Your data is protected',
    'Тип поиска': 'Search type',
    'REG номер': 'REG number',
    'VIN-код': 'VIN code',
    'Без REG / VIN': 'No REG / VIN',
    'Регистрационный номер': 'Registration number',
    'Описание техники': 'Vehicle description',
    'Например, 123ABC': 'For example, 123ABC',
    '17-значный VIN-код': '17-character VIN code',
    'Например, экскаватор CAT 320': 'For example, CAT 320 excavator',
    'Введите регистрационный номер.': 'Enter the registration number.',
    'Введите VIN-код.': 'Enter the VIN code.',
    'Опишите технику.': 'Describe the vehicle or equipment.',
    'Не удалось выполнить поиск.': 'The search could not be completed.',
    'Нет связи с сервером. Проверьте подключение и попробуйте снова.': 'Cannot reach the server. Check your connection and try again.',
    'Ищем…': 'Searching…',
    'Найти технику': 'Find vehicle',
    'Добавить технику': 'Add vehicle',
    'Проверить на Transpordiamet': 'Check with Transpordiamet',
    'Найденная техника': 'Vehicle found',
    'ТЕХНИКА НАЙДЕНА': 'VEHICLE FOUND',
    'ТЕХНИКА ДОБАВЛЕНА': 'VEHICLE ADDED',
    'Новый поиск': 'New search',
    'ДАННЫЕ ТЕХНИКИ': 'VEHICLE DETAILS',
    'Данные реестра': 'Registry data',
    'VIN расшифрован': 'VIN decoded',
    'Добавлено вручную': 'Added manually',
    'VIN успешно расшифрован. Статус регистрации в Эстонии появится после подключения реестрового API.': 'The VIN was decoded successfully. Estonian registration status will appear once a registry API is connected.',
    'Техника добавлена без REG и VIN. Уточните состояние и другие данные в сообщении.': 'The vehicle was added without REG or VIN. Add its condition and other details in the message.',
    'Источник:': 'Source:',
    'ПЕРСОНАЛЬНАЯ ОЦЕНКА': 'PERSONAL VALUATION',
    'Получить частное предложение': 'Receive a private offer',
    'Мы изучим технику и свяжемся с вами лично.': 'We will review the vehicle and contact you personally.',
    'Ваше имя *': 'Your name *',
    'Как к вам обращаться': 'How should we address you?',
    'Телефон или e-mail *': 'Phone or e-mail *',
    '+372 или e-mail': '+372 or e-mail',
    'Язык общения *': 'Contact language *',
    'Выберите язык': 'Select language',
    'Русский': 'Russian',
    'Сообщение': 'Message',
    'Опишите состояние техники и удобное время для связи': 'Describe the condition and a convenient time to contact you',
    'Согласен на обработку указанных данных для подготовки предложения.': 'I agree to the processing of the provided data to prepare an offer.',
    'Заполните имя, контакт, язык общения и подтвердите согласие.': 'Enter your name, contact and language, then confirm your consent.',
    'Отправляем заявку…': 'Sending request…',
    'Заявка отправлена': 'Request sent',
    'Спасибо. Заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.': 'Thank you. Your request has been sent successfully. We will contact you shortly.',
    'Спасибо. Заявка успешно отправлена. Подтверждение направлено на указанный e-mail.': 'Thank you. Your request has been sent successfully. A confirmation has been sent to the e-mail address provided.',
    'Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.': 'The request could not be sent. Please try again or contact us directly.',
    'Сервис отправки ещё не настроен. Свяжитесь с нами по телефону или e-mail.': 'The delivery service is not configured yet. Please contact us by phone or e-mail.',
    'Заявка отправляется автоматически и безопасно.': 'Your request is sent automatically and securely.',
    'Запросить персональную оценку': 'Request a personal valuation',
    'Получатель:': 'Recipient:',
    'Марка': 'Make',
    'Модель': 'Model',
    'Год': 'Year',
    'Первая регистрация': 'First registration',
    'Категория': 'Category',
    'Тип кузова': 'Body type',
    'Цвет': 'Colour',
    'Топливо': 'Fuel',
    'Объём двигателя': 'Engine capacity',
    'Мощность': 'Power',
    'Коробка передач': 'Transmission',
    'Привод': 'Drive type',
    'Снаряжённая масса': 'Curb weight',
    'Полная масса': 'Gross weight',
    'Количество мест': 'Seats',
    'Количество дверей': 'Doors',
    'Статус в регистре': 'Registry status',
    'Техосмотр до': 'Inspection valid until',
    'Пробег': 'Mileage',
    'Страна производства': 'Country of manufacture',
    'ЧТО МОЖНО ПРЕДЛОЖИТЬ': 'WHAT WE ACQUIRE',
    'Выберите свою': 'Choose your',
    'категорию техники': 'vehicle category',
    'Покупаем исправную и повреждённую технику у частных лиц и компаний. Каждое предложение оцениваем индивидуально.': 'We buy working and damaged vehicles from individuals and companies. Every offer is assessed individually.',
    'ЛЕГКОВОЙ ТРАНСПОРТ': 'PASSENGER VEHICLES',
    'Автомобили': 'Cars',
    'Любой возраст, пробег и состояние.': 'Any age, mileage or condition.',
    'ПРОФЕССИОНАЛЬНАЯ ТЕХНИКА': 'PROFESSIONAL EQUIPMENT',
    'Грузовики и спецтехника': 'Trucks and specialist equipment',
    'Рабочая техника для стройки, леса и логистики.': 'Working equipment for construction, forestry and logistics.',
    'ТЕХНИКА ДЛЯ ОТДЫХА': 'LEISURE VEHICLES',
    'Мото, ATV и катера': 'Motorcycles, ATVs and boats',
    'Дорожная, внедорожная и водная техника.': 'Road, off-road and water vehicles.',
    'НЕ НАШЛИ КАТЕГОРИЮ?': 'CATEGORY NOT LISTED?',
    'Предложите любую технику': 'Offer any vehicle or equipment',
    'Опишите её в сообщении — мы всё равно рассмотрим заявку.': 'Describe it in the message — we will still review your request.',
    'Отправить данные': 'Submit details',
    'ПРОСТОЙ ПРОЦЕСС': 'A SIMPLE PROCESS',
    'От номера до предложения — три шага': 'From details to offer in three steps',
    'Никаких сложных анкет. Сначала находим данные техники, затем уточняем детали и связываемся на удобном языке.': 'No complicated forms. We identify the vehicle, review your details and contact you in your preferred language.',
    'Начать оценку': 'Start valuation',
    'Найдите технику': 'Identify the vehicle',
    'Введите REG, VIN или добавьте технику без номера.': 'Enter a REG or VIN, or add a vehicle without either.',
    'Укажите контакты': 'Add your contact details',
    'Добавьте контакты и язык общения.': 'Add your contact details and preferred language.',
    'Получите предложение': 'Receive an offer',
    'Мы оценим технику и обсудим удобную сделку.': 'We will value the vehicle and discuss a convenient transaction.',
    'ПОДХОД CARCASH': 'THE CARCASH APPROACH',
    'Сначала факты.': 'Facts first.',
    'Затем предложение.': 'Then an offer.',
    'Мы заранее изучаем регистрационные данные и ваше описание техники. Поэтому разговор начинается с конкретики, а окончательные условия согласуются только после проверки состояния.': 'We review the registry data and your description in advance. The conversation starts with facts, while final terms are agreed after checking the condition.',
    'Персональная оценка': 'Personal valuation',
    'Без обязательств': 'No obligation',
    'Отправка заявки не обязывает вас продавать технику.': 'Submitting a request does not oblige you to sell.',
    'Ценим ваше время': 'We value your time',
    'Данные подставляются автоматически и безопасно отправляются нашей команде.': 'The details are added automatically and sent securely to our team.',
    'Выберите удобный язык до отправки заявки.': 'Choose your preferred language before submitting.',
    'ВОПРОСЫ И ОТВЕТЫ': 'QUESTIONS & ANSWERS',
    'Коротко о главном': 'The essentials',
    'Не нашли ответ? Напишите нам напрямую — разберём ваше предложение индивидуально.': 'Could not find an answer? Write to us directly and we will review your case individually.',
    'ЕСТЬ ТЕХНИКА НА ПРОДАЖУ?': 'HAVE A VEHICLE TO SELL?',
    'Начнём с точной оценки вашей техники.': 'Let us start with an accurate valuation.',
    'Начнём с точной оценки': 'Let us start with an accurate valuation',
    'вашей техники.': 'of your vehicle.',
    'Предварительная оценка без обязательств. Работаем по всей Эстонии и рассматриваем любую технику.': 'A preliminary valuation with no obligation. We work across Estonia and consider all types of vehicles and equipment.',
    'RU · ET · EN — ответим на удобном языке': 'RU · ET · EN — we will reply in your preferred language',
    'Получить оценку': 'Get a valuation',
    'Персональная оценка и выкуп техники по всей Эстонии.': 'Personal valuation and vehicle acquisition throughout Estonia.',
    'Навигация': 'Navigation',
    'Документы': 'Documents',
    'Политика конфиденциальности': 'Privacy Policy',
    'Условия использования': 'Terms of Use',
    'Наверх': 'Back to top',
    'На главную': 'Back to home',
    'Файлы cookie и конфиденциальность': 'Cookies and privacy',
    'Мы используем необходимые технологии для работы сайта и сохранения выбранного языка. Дополнительные технологии могут использоваться только с вашего согласия.': 'We use essential technologies to operate the site and remember your language. Additional technologies may only be used with your consent.',
    'Подробнее': 'Learn more',
    'Только необходимые': 'Essential only',
    'Принять': 'Accept',
    'Контакты': 'Contacts',
    'Юридические данные': 'Company details',
    'Регистрационный код': 'Registry code',
    'Юридический адрес': 'Registered address',
    'Открыть в e-Äriregister': 'View in e-Business Register',
    'Вся Эстония': 'All of Estonia',
    'Языки': 'Languages',
    'Все права защищены.': 'All rights reserved.',
    'Данные реестра носят информационный характер.': 'Registry data is provided for information only.',
    'Как быстро я получу предложение?': 'How quickly will I receive an offer?',
    'Обычно мы связываемся в течение рабочего дня. Чем точнее данные техники и описание её состояния, тем быстрее сможем назвать предварительную цену.': 'We usually get in touch within one business day. Accurate details and a clear description help us provide an initial price sooner.',
    'Какую технику вы покупаете?': 'What vehicles and equipment do you buy?',
    'Автомобили, мотоциклы, грузовики, спецтехнику, прицепы, ATV/UTV и катера. Рассматриваем исправную, повреждённую, кредитную и неиспользуемую технику.': 'Cars, motorcycles, trucks, specialist equipment, trailers, ATVs/UTVs and boats. We consider working, damaged, financed and unused vehicles.',
    'Обязательно ли знать VIN?': 'Do I need to know the VIN?',
    'Нет. Для зарегистрированной в Эстонии техники можно начать с REG номера. VIN даёт более точную идентификацию и особенно полезен для техники без номерного знака.': 'No. For vehicles registered in Estonia, you can start with the REG number. You can also submit equipment without either identifier.',
    'Вы работаете за пределами Таллинна?': 'Do you operate outside Tallinn?',
    'Да, заявки принимаются по всей Эстонии. Место осмотра и способ вывоза согласуем после предварительной оценки.': 'Yes. We accept requests throughout Estonia. Inspection and collection are arranged after the initial valuation.',
  },
  et: {
    'Открыть чат': 'Ava vestlus',
    'Закрыть чат': 'Sulge vestlus',
    'Напишите нам': 'Kirjutage meile',
    'Чат с CarCash': 'Vestlus CarCashiga',
    'Напишите нам — ответ появится здесь.': 'Kirjutage meile — vastus ilmub siia.',
    'Обычно отвечаем в рабочее время': 'Vastame tavaliselt tööajal',
    'E-mail или телефон': 'E-post või telefon',
    'Ваше сообщение': 'Teie sõnum',
    'Напишите сообщение…': 'Kirjutage sõnum…',
    'Отправить сообщение': 'Saada sõnum',
    'Не удалось отправить сообщение. Попробуйте ещё раз.': 'Sõnumi saatmine ebaõnnestus. Proovige uuesti.',
    'Чат временно недоступен.': 'Vestlus pole ajutiselt saadaval.',
    'Диалог завершён': 'Vestlus on lõpetatud',
    'Этот диалог был закрыт. Если хотите продолжить, начните новый.': 'See vestlus on lõpetatud. Kui soovite jätkata, alustage uut vestlust.',
    'Начать новый диалог': 'Alusta uut vestlust',
    'Вы': 'Teie',
    'Команда CarCash': 'CarCashi meeskond',
    'Отправляя сообщение, вы соглашаетесь с обработкой данных согласно': 'Sõnumi saatmisega nõustute andmete töötlemisega vastavalt',
    'политике конфиденциальности': 'privaatsuspoliitikale',
    'CarCash — на главную': 'CarCash — avaleht',
    'Основная навигация': 'Põhinavigatsioon',
    'Язык интерфейса': 'Kasutajaliidese keel',
    'Что покупаем': 'Mida ostame',
    'Как это работает': 'Kuidas see toimib',
    'Вопросы': 'Küsimused',
    'Позвонить нам': 'Helistage meile',
    'Оценить технику': 'Hinda tehnikat',
    'Закрыть меню': 'Sulge menüü',
    'Открыть меню': 'Ava menüü',
    'Перейти к содержанию': 'Liigu sisu juurde',
    'ВЫКУП ТЕХНИКИ · ЭСТОНИЯ': 'TEHNIKA OST · EESTI',
    'Точная оценка.': 'Täpne hindamine.',
    'Честная сделка.': 'Aus tehing.',
    'Автомобили, коммерческий транспорт и специальная техника. Найдите объект по REG или VIN и получите персональное предложение.': 'Sõiduautod, tarbesõidukid ja eritehnika. Otsige REG-numbri või VIN-koodi järgi või lisage tehnika käsitsi ning saate personaalse pakkumise.',
    'Бюджет на выкуп не ограничен': 'Ostueelarve ei ole piiratud',
    'Автомобиль, грузовик, экскаватор, мотоцикл и катер, которые покупает CarCash': 'Auto, veok, ekskavaator, mootorratas ja paat, mida CarCash ostab',
    'ПРОВЕРКА ТЕХНИКИ': 'TEHNIKA KONTROLL',
    'Найдём данные за минуту': 'Leiame andmed minutiga',
    'REG, VIN или описание — выберите удобный способ идентификации.': 'REG, VIN või kirjeldus — valige teile sobiv tuvastusviis.',
    'Данные защищены': 'Andmed on kaitstud',
    'Тип поиска': 'Otsingu tüüp',
    'REG номер': 'REG number',
    'VIN-код': 'VIN-kood',
    'Без REG / VIN': 'Ilma REG / VIN-ita',
    'Регистрационный номер': 'Registreerimisnumber',
    'Описание техники': 'Tehnika kirjeldus',
    'Например, 123ABC': 'Näiteks 123ABC',
    '17-значный VIN-код': '17-kohaline VIN-kood',
    'Например, экскаватор CAT 320': 'Näiteks ekskavaator CAT 320',
    'Введите регистрационный номер.': 'Sisestage registreerimisnumber.',
    'Введите VIN-код.': 'Sisestage VIN-kood.',
    'Опишите технику.': 'Kirjeldage tehnikat.',
    'Не удалось выполнить поиск.': 'Otsingut ei õnnestunud teha.',
    'Нет связи с сервером. Проверьте подключение и попробуйте снова.': 'Serveriga puudub ühendus. Kontrollige ühendust ja proovige uuesti.',
    'Ищем…': 'Otsime…',
    'Найти технику': 'Leia tehnika',
    'Добавить технику': 'Lisa tehnika',
    'Проверить на Transpordiamet': 'Kontrolli Transpordiametis',
    'Найденная техника': 'Leitud tehnika',
    'ТЕХНИКА НАЙДЕНА': 'TEHNIKA LEITUD',
    'ТЕХНИКА ДОБАВЛЕНА': 'TEHNIKA LISATUD',
    'Новый поиск': 'Uus otsing',
    'ДАННЫЕ ТЕХНИКИ': 'TEHNIKA ANDMED',
    'Данные реестра': 'Registriandmed',
    'VIN расшифрован': 'VIN dekodeeritud',
    'Добавлено вручную': 'Käsitsi lisatud',
    'VIN успешно расшифрован. Статус регистрации в Эстонии появится после подключения реестрового API.': 'VIN dekodeeriti edukalt. Eesti registristaatus ilmub pärast registri API ühendamist.',
    'Техника добавлена без REG и VIN. Уточните состояние и другие данные в сообщении.': 'Tehnika lisati ilma REG-numbri ja VIN-koodita. Täpsustage seisukord ja muud andmed sõnumis.',
    'Источник:': 'Allikas:',
    'ПЕРСОНАЛЬНАЯ ОЦЕНКА': 'PERSONAALNE HINDAMINE',
    'Получить частное предложение': 'Saage personaalne pakkumine',
    'Мы изучим технику и свяжемся с вами лично.': 'Tutvume tehnikaga ja võtame teiega isiklikult ühendust.',
    'Ваше имя *': 'Teie nimi *',
    'Как к вам обращаться': 'Kuidas teie poole pöörduda?',
    'Телефон или e-mail *': 'Telefon või e-post *',
    '+372 или e-mail': '+372 või e-post',
    'Язык общения *': 'Suhtluskeel *',
    'Выберите язык': 'Valige keel',
    'Русский': 'Vene',
    'Сообщение': 'Sõnum',
    'Опишите состояние техники и удобное время для связи': 'Kirjeldage tehnika seisukorda ja sobivat ühenduse võtmise aega',
    'Согласен на обработку указанных данных для подготовки предложения.': 'Nõustun esitatud andmete töötlemisega pakkumise koostamiseks.',
    'Заполните имя, контакт, язык общения и подтвердите согласие.': 'Sisestage nimi, kontakt ja suhtluskeel ning kinnitage nõusolek.',
    'Отправляем заявку…': 'Saadame taotlust…',
    'Заявка отправлена': 'Taotlus on saadetud',
    'Спасибо. Заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.': 'Aitäh. Teie taotlus on edukalt saadetud. Võtame teiega peagi ühendust.',
    'Спасибо. Заявка успешно отправлена. Подтверждение направлено на указанный e-mail.': 'Aitäh. Teie taotlus on edukalt saadetud. Kinnitus saadeti sisestatud e-posti aadressile.',
    'Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.': 'Taotluse saatmine ebaõnnestus. Proovige uuesti või võtke meiega otse ühendust.',
    'Сервис отправки ещё не настроен. Свяжитесь с нами по телефону или e-mail.': 'Saatmisteenus ei ole veel seadistatud. Võtke meiega ühendust telefoni või e-posti teel.',
    'Заявка отправляется автоматически и безопасно.': 'Taotlus saadetakse automaatselt ja turvaliselt.',
    'Запросить персональную оценку': 'Küsi personaalset hinnangut',
    'Получатель:': 'Saaja:',
    'Марка': 'Mark',
    'Модель': 'Mudel',
    'Год': 'Aasta',
    'Первая регистрация': 'Esmaregistreerimine',
    'Категория': 'Kategooria',
    'Тип кузова': 'Keretüüp',
    'Цвет': 'Värv',
    'Топливо': 'Kütus',
    'Объём двигателя': 'Mootori töömaht',
    'Мощность': 'Võimsus',
    'Коробка передач': 'Käigukast',
    'Привод': 'Vedav sild',
    'Снаряжённая масса': 'Tühimass',
    'Полная масса': 'Täismass',
    'Количество мест': 'Istekohti',
    'Количество дверей': 'Uksi',
    'Статус в регистре': 'Registristaatus',
    'Техосмотр до': 'Ülevaatus kehtib kuni',
    'Пробег': 'Läbisõit',
    'Страна производства': 'Tootjariik',
    'ЧТО МОЖНО ПРЕДЛОЖИТЬ': 'MIDA SAAB PAKKUDA',
    'Выберите свою': 'Valige oma',
    'категорию техники': 'tehnika kategooria',
    'Покупаем исправную и повреждённую технику у частных лиц и компаний. Каждое предложение оцениваем индивидуально.': 'Ostame töökorras ja kahjustatud tehnikat eraisikutelt ning ettevõtetelt. Iga pakkumist hindame individuaalselt.',
    'ЛЕГКОВОЙ ТРАНСПОРТ': 'SÕIDUAUTOD',
    'Автомобили': 'Autod',
    'Любой возраст, пробег и состояние.': 'Igas vanuses, läbisõidu ja seisukorraga.',
    'ПРОФЕССИОНАЛЬНАЯ ТЕХНИКА': 'PROFESSIONAALNE TEHNIKA',
    'Грузовики и спецтехника': 'Veokid ja eritehnika',
    'Рабочая техника для стройки, леса и логистики.': 'Töötehnika ehituseks, metsatööks ja logistikaks.',
    'ТЕХНИКА ДЛЯ ОТДЫХА': 'VABA AJA TEHNIKA',
    'Мото, ATV и катера': 'Mootorrattad, ATV-d ja paadid',
    'Дорожная, внедорожная и водная техника.': 'Maantee-, maastiku- ja veetehnika.',
    'НЕ НАШЛИ КАТЕГОРИЮ?': 'KATEGOORIAT EI LEIDNUD?',
    'Предложите любую технику': 'Pakkuge mis tahes tehnikat',
    'Опишите её в сообщении — мы всё равно рассмотрим заявку.': 'Kirjeldage seda sõnumis — vaatame teie taotluse siiski üle.',
    'Отправить данные': 'Saada andmed',
    'ПРОСТОЙ ПРОЦЕСС': 'LIHTNE PROTSESS',
    'От номера до предложения — три шага': 'Andmetest pakkumiseni kolme sammuga',
    'Никаких сложных анкет. Сначала находим данные техники, затем уточняем детали и связываемся на удобном языке.': 'Ei mingeid keerulisi ankeete. Tuvastame tehnika, vaatame andmed üle ja võtame ühendust teile sobivas keeles.',
    'Начать оценку': 'Alusta hindamist',
    'Найдите технику': 'Tuvastage tehnika',
    'Введите REG, VIN или добавьте технику без номера.': 'Sisestage REG või VIN või lisage tehnika ilma nendeta.',
    'Укажите контакты': 'Lisage kontaktandmed',
    'Добавьте контакты и язык общения.': 'Lisage kontaktandmed ja suhtluskeel.',
    'Получите предложение': 'Saage pakkumine',
    'Мы оценим технику и обсудим удобную сделку.': 'Hindame tehnikat ja lepime kokku sobiva tehingu.',
    'ПОДХОД CARCASH': 'CARCASHI LÄHENEMINE',
    'Сначала факты.': 'Kõigepealt faktid.',
    'Затем предложение.': 'Seejärel pakkumine.',
    'Мы заранее изучаем регистрационные данные и ваше описание техники. Поэтому разговор начинается с конкретики, а окончательные условия согласуются только после проверки состояния.': 'Tutvume eelnevalt registriandmete ja teie kirjeldusega. Vestlus algab faktidest ning lõplikud tingimused lepime kokku pärast seisukorra kontrolli.',
    'Персональная оценка': 'Personaalne hindamine',
    'Без обязательств': 'Kohustusteta',
    'Отправка заявки не обязывает вас продавать технику.': 'Taotluse saatmine ei kohusta teid tehnikat müüma.',
    'Ценим ваше время': 'Väärtustame teie aega',
    'Данные подставляются автоматически и безопасно отправляются нашей команде.': 'Andmed lisatakse automaatselt ja saadetakse turvaliselt meie meeskonnale.',
    'Выберите удобный язык до отправки заявки.': 'Valige enne taotluse saatmist sobiv keel.',
    'ВОПРОСЫ И ОТВЕТЫ': 'KÜSIMUSED JA VASTUSED',
    'Коротко о главном': 'Oluline lühidalt',
    'Не нашли ответ? Напишите нам напрямую — разберём ваше предложение индивидуально.': 'Ei leidnud vastust? Kirjutage meile ja vaatame teie pakkumise individuaalselt üle.',
    'ЕСТЬ ТЕХНИКА НА ПРОДАЖУ?': 'SOOVITE TEHNIKAT MÜÜA?',
    'Начнём с точной оценки вашей техники.': 'Alustame teie tehnika täpsest hindamisest.',
    'Начнём с точной оценки': 'Alustame teie tehnika',
    'вашей техники.': 'täpsest hindamisest.',
    'Предварительная оценка без обязательств. Работаем по всей Эстонии и рассматриваем любую технику.': 'Esmane hindamine ilma kohustusteta. Töötame üle Eesti ja vaatame läbi igat liiki tehnika.',
    'RU · ET · EN — ответим на удобном языке': 'RU · ET · EN — vastame teile sobivas keeles',
    'Получить оценку': 'Küsi hinnangut',
    'Персональная оценка и выкуп техники по всей Эстонии.': 'Tehnika personaalne hindamine ja ost üle Eesti.',
    'Навигация': 'Navigatsioon',
    'Документы': 'Dokumendid',
    'Политика конфиденциальности': 'Privaatsuspoliitika',
    'Условия использования': 'Kasutustingimused',
    'Наверх': 'Tagasi üles',
    'На главную': 'Tagasi avalehele',
    'Файлы cookie и конфиденциальность': 'Küpsised ja privaatsus',
    'Мы используем необходимые технологии для работы сайта и сохранения выбранного языка. Дополнительные технологии могут использоваться только с вашего согласия.': 'Kasutame veebilehe toimimiseks ja valitud keele salvestamiseks vajalikke tehnoloogiaid. Täiendavaid tehnoloogiaid kasutatakse ainult teie nõusolekul.',
    'Подробнее': 'Lisateave',
    'Только необходимые': 'Ainult vajalikud',
    'Принять': 'Nõustun',
    'Контакты': 'Kontaktid',
    'Юридические данные': 'Ettevõtte andmed',
    'Регистрационный код': 'Registrikood',
    'Юридический адрес': 'Registrijärgne aadress',
    'Открыть в e-Äriregister': 'Vaata e-Äriregistris',
    'Вся Эстония': 'Kogu Eesti',
    'Языки': 'Keeled',
    'Все права защищены.': 'Kõik õigused kaitstud.',
    'Данные реестра носят информационный характер.': 'Registriandmed on informatiivsed.',
    'Как быстро я получу предложение?': 'Kui kiiresti saan pakkumise?',
    'Обычно мы связываемся в течение рабочего дня. Чем точнее данные техники и описание её состояния, тем быстрее сможем назвать предварительную цену.': 'Võtame tavaliselt ühendust ühe tööpäeva jooksul. Täpsed andmed ja seisukorra kirjeldus aitavad esialgse hinna kiiremini anda.',
    'Какую технику вы покупаете?': 'Millist tehnikat te ostate?',
    'Автомобили, мотоциклы, грузовики, спецтехнику, прицепы, ATV/UTV и катера. Рассматриваем исправную, повреждённую, кредитную и неиспользуемую технику.': 'Autosid, mootorrattaid, veokeid, eritehnikat, haagiseid, ATV/UTV-sid ja paate. Vaatame üle nii töökorras, kahjustatud, liisingus kui kasutuseta tehnika.',
    'Обязательно ли знать VIN?': 'Kas VIN-koodi peab teadma?',
    'Нет. Для зарегистрированной в Эстонии техники можно начать с REG номера. VIN даёт более точную идентификацию и особенно полезен для техники без номерного знака.': 'Ei. Eestis registreeritud tehnika puhul piisab REG-numbrist. Tehnika saab esitada ka ilma mõlema tunnuseta.',
    'Вы работаете за пределами Таллинна?': 'Kas tegutsete väljaspool Tallinna?',
    'Да, заявки принимаются по всей Эстонии. Место осмотра и способ вывоза согласуем после предварительной оценки.': 'Jah, võtame taotlusi vastu üle Eesti. Ülevaatuse ja äraveo lepime kokku pärast esmast hindamist.',
  },
}

function translate(locale, text) {
  return translations[locale]?.[text] || text
}

function scrollToPageSection(event, sectionId, { focus = false } = {}) {
  event.preventDefault()
  const target = document.getElementById(sectionId)
  if (!target) return

  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'start',
  })
  if (focus) target.focus({ preventScroll: true })

  window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`)
}

const faqItems = [
  {
    question: 'Как быстро я получу предложение?',
    answer: 'Обычно мы связываемся в течение рабочего дня. Чем точнее данные техники и описание её состояния, тем быстрее сможем назвать предварительную цену.',
  },
  {
    question: 'Какую технику вы покупаете?',
    answer: 'Автомобили, мотоциклы, грузовики, спецтехнику, прицепы, ATV/UTV и катера. Рассматриваем исправную, повреждённую, кредитную и неиспользуемую технику.',
  },
  {
    question: 'Обязательно ли знать VIN?',
    answer: 'Нет. Для зарегистрированной в Эстонии техники можно начать с REG номера. VIN даёт более точную идентификацию и особенно полезен для техники без номерного знака.',
  },
  {
    question: 'Вы работаете за пределами Таллинна?',
    answer: 'Да, заявки принимаются по всей Эстонии. Место осмотра и способ вывоза согласуем после предварительной оценки.',
  },
]

const legalDocuments = {
  ru: {
    privacy: {
      eyebrow: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ',
      title: 'Политика конфиденциальности',
      updated: 'Редакция от 29 июля 2026 года',
      intro: 'Настоящая политика объясняет, как CarCash обрабатывает персональные данные при использовании сайта и запросе оценки техники.',
      sections: [
        ['1. Оператор данных', 'Оператором персональных данных и владельцем сервиса CarCash является Osaühing SVENTLI AUTO, регистрационный код 11002829, юридический адрес: Rakvere tn 19, Jõhvi linn, Jõhvi vald, Ida-Viru maakond, 41533, Eesti. По вопросам обработки данных и реализации ваших прав используйте контактный e-mail, указанный на этой странице.'],
        ['2. Какие данные обрабатываются', 'Мы можем обрабатывать имя, телефон или e-mail, язык общения, сообщения онлайн-чата, REG-номер, VIN-код, описание и технические характеристики техники. Сервер также может временно обрабатывать IP-адрес, идентификатор диалога и технические сведения, необходимые для безопасности и работы сайта.'],
        ['3. Цели и правовые основания', 'Данные используются для идентификации техники, подготовки и обсуждения предложения, ответа на обращение, предотвращения злоупотреблений и выполнения применимых юридических обязанностей. Основаниями являются действия до заключения договора по вашему запросу, законный интерес к безопасной работе сервиса, согласие — когда оно требуется, и требования закона.'],
        ['4. Как отправляется заявка', 'После отправки формы сервер автоматически направляет отдельные письма двум настроенным получателям через Resend. Если в поле контакта указан e-mail, после успешной доставки заявки компания также отправляет на него автоматическое подтверждение на русском, эстонском и английском языках. Дополнительно копия может поступать в закрытый административный канал для внутреннего контроля обращений. Пользователю не требуется самостоятельно отправлять письмо. CarCash не сохраняет заявку в отдельной базе данных.'],
        ['5. Получатели и внешние сервисы', 'Доступ к данным получают CarCash и поставщики, необходимые для хостинга, доставки электронной почты через Resend, работы административного чата через Telegram, безопасности и получения технических данных по REG или VIN. Сообщения онлайн-чата передаются в закрытую Telegram-группу CarCash, где для каждого посетителя создаётся отдельная тема. Мы не продаём персональные данные. При передаче данных за пределы ЕЭЗ применяются предусмотренные законом гарантии.'],
        ['6. Срок хранения', 'Переписка по заявке и сообщения онлайн-чата, которые не привели к сделке, могут храниться до 12 месяцев после последнего контакта. Документы по завершённой сделке хранятся в сроки, установленные бухгалтерским и иным применимым законодательством. Технические журналы безопасности хранятся только необходимый период.'],
        ['7. Ваши права', 'Вы вправе запросить доступ, исправление или удаление данных, ограничить обработку, возразить против неё, получить переносимую копию данных и отозвать согласие. Также можно подать жалобу в Andmekaitse Inspektsioon. Для выполнения запроса может потребоваться подтверждение личности.'],
        ['8. Аналитика, локальное хранилище и внешние ресурсы', 'Выбранный язык, идентификатор онлайн-чата и введённые для чата контактные данные сохраняются локально в браузере. Только после вашего согласия для анализа посещаемости и взаимодействия с сайтом загружается Яндекс.Метрика, включая Webvisor: сервис может получать IP-адрес, сведения о браузере и устройстве, источнике перехода, посещённых страницах и действиях на сайте. Бейдж SiteLens загружается с sitelens.ee без передачи referrer и без cross-origin credentials; внешний сервер при этом получает обычные технические данные соединения, включая IP-адрес.'],
        ['9. Изменения политики', 'Политика может обновляться при изменении функций сайта или требований закона. Актуальная редакция всегда публикуется на этой странице.'],
      ],
    },
    terms: {
      eyebrow: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ',
      title: 'Условия использования',
      updated: 'Редакция от 29 июля 2026 года',
      intro: 'Используя сайт CarCash, вы соглашаетесь с настоящими условиями. Сервис предназначен для предварительной оценки и обсуждения возможного выкупа техники в Эстонии.',
      sections: [
        ['1. Назначение сервиса', 'Сервис CarCash предоставляется компанией Osaühing SVENTLI AUTO, регистрационный код 11002829. Сайт позволяет найти часть технических данных по REG или VIN либо добавить технику вручную, после чего подготовить обращение. Отправка формы является запросом на оценку и не создаёт обязанность заключить сделку.'],
        ['2. Предварительное предложение', 'Любая цена или оценка, сообщённая до осмотра, является предварительной. Окончательная цена, порядок оплаты, передача техники, вывоз и иные условия согласуются отдельно после проверки состояния, документов и права собственности.'],
        ['3. Данные пользователя', 'Пользователь обязуется указывать достоверные сведения, иметь законное право предлагать технику и сообщать об известных ограничениях, залоге, лизинге, повреждениях и иных обстоятельствах, влияющих на сделку.'],
        ['4. REG, VIN и данные реестров', 'Реестровые и декодированные данные предоставляются для удобства и могут быть неполными или устаревшими. CarCash не гарантирует их абсолютную точность и проверяет существенные сведения перед заключением сделки.'],
        ['5. Бюджет на выкуп', 'Сообщение о неограниченном бюджете означает отсутствие заранее установленного общего лимита на рассмотрение заявок и не гарантирует выкуп конкретной техники или согласие с предварительной оценкой.'],
        ['6. Доставка заявки, онлайн-чат и внешние сервисы', 'Сервер автоматически отправляет заявку двум настроенным получателям через Resend. После успешной отправки заявки на указанный пользователем e-mail направляется трёхъязычное автоматическое подтверждение. Сообщения онлайн-чата передаются в закрытую Telegram-группу CarCash; для каждого посетителя создаётся отдельная тема, а ответы уполномоченных администраторов отображаются в том же чате на сайте. Если внешний сервис не подтвердит доставку, сайт покажет сообщение об ошибке.'],
        ['7. Ограничение ответственности', 'Сайт предоставляется в доступном виде. CarCash не отвечает за временные технические сбои, действия внешних провайдеров или решения, принятые исключительно на основании предварительных данных сайта. Ограничения не применяются там, где ответственность нельзя исключить по закону.'],
        ['8. Интеллектуальная собственность и право', 'Дизайн, тексты и материалы сайта защищены законом. Их коммерческое копирование без разрешения запрещено. К использованию сайта применяется право Эстонской Республики; обязательные права потребителей сохраняются в предусмотренном законом объёме.'],
        ['9. Изменения и контакты', 'CarCash может обновлять условия при развитии сервиса или изменении законодательства. Актуальная версия публикуется на этой странице. По вопросам используйте указанные ниже контакты.'],
      ],
    },
  },
  et: {
    privacy: {
      eyebrow: 'ÕIGUSLIK TEAVE',
      title: 'Privaatsuspoliitika',
      updated: 'Versioon 29. juulist 2026',
      intro: 'Käesolev poliitika selgitab, kuidas CarCash töötleb isikuandmeid veebilehe kasutamisel ja tehnika hindamise taotlemisel.',
      sections: [
        ['1. Vastutav töötleja', 'Isikuandmete vastutav töötleja ja CarCashi teenuse omanik on Osaühing SVENTLI AUTO, registrikood 11002829, registrijärgne aadress: Rakvere tn 19, Jõhvi linn, Jõhvi vald, Ida-Viru maakond, 41533, Eesti. Andmetöötluse ja oma õiguste kasutamise küsimustes võtke ühendust sellel lehel märgitud e-posti aadressil.'],
        ['2. Töödeldavad andmed', 'Võime töödelda nime, telefoni või e-posti, suhtluskeelt, veebivestluse sõnumeid, REG-numbrit, VIN-koodi ning tehnika kirjeldust ja tehnilisi andmeid. Server võib turvalisuse ja töö tagamiseks ajutiselt töödelda ka IP-aadressi, vestluse identifikaatorit ning tehnilist teavet.'],
        ['3. Eesmärgid ja õiguslikud alused', 'Andmeid kasutatakse tehnika tuvastamiseks, pakkumise ettevalmistamiseks ja arutamiseks, päringule vastamiseks, kuritarvituste vältimiseks ning õiguslike kohustuste täitmiseks. Aluseks on teie taotlusel lepingueelsed toimingud, õigustatud huvi turvalise teenuse vastu, vajaduse korral nõusolek ja seadusest tulenevad kohustused.'],
        ['4. Taotluse saatmine', 'Pärast vormi saatmist edastab server Resendi kaudu automaatselt eraldi e-kirjad kahele seadistatud vastuvõtjale. Kui kontaktiväljale on sisestatud e-posti aadress, saadab ettevõte pärast taotluse edukat edastamist sellele automaatse kinnituse vene, eesti ja inglise keeles. Lisaks võib koopia jõuda suletud halduskanalisse taotluste sisemiseks jälgimiseks. Kasutaja ei pea e-kirja ise saatma. CarCash ei salvesta taotlust eraldi andmebaasi.'],
        ['5. Vastuvõtjad ja välised teenused', 'Andmetele pääsevad ligi CarCash ning hostingu, Resendi kaudu e-kirjade edastamise, Telegrami kaudu haldusvestluse, turvalisuse ja REG- või VIN-andmete teenusepakkujad vajalikus ulatuses. Veebivestluse sõnumid edastatakse CarCashi suletud Telegrami gruppi, kus igale külastajale luuakse eraldi teema. Me ei müü isikuandmeid. Väljapoole EMP-d edastamisel kasutatakse seaduses nõutud kaitsemeetmeid.'],
        ['6. Säilitamine', 'Tehinguni mitte jõudnud taotluse kirjavahetust ja veebivestluse sõnumeid võidakse säilitada kuni 12 kuud viimasest kontaktist. Lõpetatud tehingu dokumente säilitatakse raamatupidamis- ja muu kohaldatava õiguse järgi. Turvalisuse tehnilisi logisid hoitakse ainult vajaliku aja.'],
        ['7. Teie õigused', 'Teil on õigus taotleda juurdepääsu, parandamist või kustutamist, piirata töötlemist, esitada vastuväiteid, saada andmed ülekantaval kujul ja võtta nõusolek tagasi. Samuti võite pöörduda Andmekaitse Inspektsiooni poole. Taotluse täitmiseks võib olla vaja isikut tuvastada.'],
        ['8. Analüütika, kohalik salvestus ja välised ressursid', 'Valitud keel, veebivestluse identifikaator ja vestlusse sisestatud kontaktandmed salvestatakse brauseris lokaalselt. Yandex Metrica koos Webvisoriga laaditakse veebilehe külastatavuse ja kasutamise analüüsimiseks alles pärast teie nõusolekut; teenus võib saada IP-aadressi, brauseri ja seadme andmeid, suunamisallikat, külastatud lehti ning veebilehel tehtud toiminguid. SiteLensi märgis laaditakse saidilt sitelens.ee ilma referrer’ita ja cross-origin credentials’ita; väline server saab siiski ühenduse tavapärased tehnilised andmed, sealhulgas IP-aadressi.'],
        ['9. Poliitika muudatused', 'Poliitikat võidakse muuta koos veebilehe funktsioonide või õigusnõuete muutumisega. Kehtiv versioon avaldatakse alati sellel lehel.'],
      ],
    },
    terms: {
      eyebrow: 'ÕIGUSLIK TEAVE',
      title: 'Kasutustingimused',
      updated: 'Versioon 29. juulist 2026',
      intro: 'CarCashi veebilehte kasutades nõustute käesolevate tingimustega. Teenus on mõeldud tehnika esmaseks hindamiseks ja võimaliku ostu arutamiseks Eestis.',
      sections: [
        ['1. Teenuse eesmärk', 'CarCashi teenust osutab Osaühing SVENTLI AUTO, registrikood 11002829. Veebileht võimaldab leida osa tehnilistest andmetest REG-numbri või VIN-koodi järgi või lisada tehnika käsitsi ning seejärel koostada päringu. Vormi saatmine on hindamistaotlus ega kohusta tehingut sõlmima.'],
        ['2. Esialgne pakkumine', 'Enne ülevaatust antud hind või hinnang on esialgne. Lõplik hind, maksmine, tehnika üleandmine, äravedu ja muud tingimused lepitakse kokku pärast seisukorra, dokumentide ja omandiõiguse kontrolli.'],
        ['3. Kasutaja andmed', 'Kasutaja peab esitama õiged andmed, omama seaduslikku õigust tehnikat pakkuda ning teatama teadaolevatest piirangutest, pandist, liisingust, kahjustustest ja muudest tehingut mõjutavatest asjaoludest.'],
        ['4. REG-, VIN- ja registriandmed', 'Registri- ja dekodeeritud andmed on mõeldud mugavuseks ning võivad olla puudulikud või aegunud. CarCash ei taga nende absoluutset täpsust ja kontrollib olulisi andmeid enne tehingut.'],
        ['5. Ostueelarve', 'Piiramatu ostueelarve tähendab, et taotluste läbivaatamiseks puudub eelnevalt määratud üldine limiit; see ei taga konkreetse tehnika ostmist ega nõustumist esialgse hinnanguga.'],
        ['6. Taotluse edastamine, veebivestlus ja välised teenused', 'Server saadab taotluse Resendi kaudu automaatselt kahele seadistatud vastuvõtjale. Pärast taotluse edukat saatmist edastatakse kasutaja sisestatud e-posti aadressile kolmekeelne automaatne kinnitus. Veebivestluse sõnumid edastatakse CarCashi suletud Telegrami gruppi; igale külastajale luuakse eraldi teema ning volitatud haldajate vastused kuvatakse samas veebivestluses. Kui väline teenus ei kinnita edastamist, kuvab veebileht veateate.'],
        ['7. Vastutuse piirang', 'Veebileht pakutakse olemasoleval kujul. CarCash ei vastuta ajutiste tehniliste rikete, väliste teenusepakkujate tegevuse ega üksnes esialgsete veebilehe andmete põhjal tehtud otsuste eest. Piirangud ei kehti ulatuses, milles vastutust ei saa seaduse järgi välistada.'],
        ['8. Intellektuaalomand ja õigus', 'Veebilehe kujundus, tekstid ja materjalid on kaitstud. Nende äriline kopeerimine loata on keelatud. Veebilehe kasutamisele kohaldatakse Eesti Vabariigi õigust; tarbijate kohustuslikud õigused säilivad seaduses ette nähtud ulatuses.'],
        ['9. Muudatused ja kontakt', 'CarCash võib tingimusi teenuse või seaduse muutumisel uuendada. Kehtiv versioon avaldatakse sellel lehel. Küsimuste korral kasutage alltoodud kontakte.'],
      ],
    },
  },
  en: {
    privacy: {
      eyebrow: 'LEGAL INFORMATION',
      title: 'Privacy Policy',
      updated: 'Version dated 29 July 2026',
      intro: 'This policy explains how CarCash processes personal data when you use the website and request a vehicle valuation.',
      sections: [
        ['1. Data controller', 'The data controller and owner of the CarCash service is Osaühing SVENTLI AUTO, registry code 11002829, registered address: Rakvere tn 19, Jõhvi linn, Jõhvi vald, Ida-Viru maakond, 41533, Estonia. For questions about data processing or exercising your rights, use the contact e-mail shown on this page.'],
        ['2. Data we process', 'We may process your name, phone or e-mail, contact language, website chat messages, REG number, VIN code, and vehicle description and technical details. The server may temporarily process an IP address, chat identifier and technical information required for security and operation.'],
        ['3. Purposes and legal bases', 'Data is used to identify the vehicle, prepare and discuss an offer, answer your request, prevent abuse and comply with legal obligations. The bases are pre-contractual steps at your request, legitimate interests in operating a secure service, consent where required, and legal obligations.'],
        ['4. How a request is sent', 'After the form is submitted, the server automatically sends separate e-mails to two configured recipients through Resend. If an e-mail address is entered in the contact field, the company also sends an automatic confirmation in Russian, Estonian and English after the request has been delivered successfully. A copy may also reach a private administrative channel for internal request tracking. The user does not need to send an e-mail manually. CarCash does not store the request in a separate database.'],
        ['5. Recipients and external services', 'Data is accessible to CarCash and providers required for hosting, e-mail delivery through Resend, the administrative chat through Telegram, security and REG or VIN technical data. Website chat messages are sent to CarCash’s private Telegram group, where a separate topic is created for each visitor. We do not sell personal data. Transfers outside the EEA use safeguards required by law.'],
        ['6. Retention', 'Correspondence for a request and website chat messages that do not lead to a transaction may be kept for up to 12 months after the last contact. Completed transaction documents are retained as required by accounting and other applicable laws. Security logs are retained only as long as necessary.'],
        ['7. Your rights', 'You may request access, correction or deletion, restrict or object to processing, obtain a portable copy and withdraw consent. You may also lodge a complaint with the Estonian Data Protection Inspectorate. Identity verification may be required.'],
        ['8. Analytics, local storage and external resources', 'Your selected language, website chat identifier and contact details entered in the chat are stored locally in the browser. Yandex Metrica with Webvisor is loaded to analyse website visits and interactions only after you consent; the service may receive the IP address, browser and device information, referral source, visited pages and actions performed on the website. The SiteLens badge is loaded from sitelens.ee without a referrer or cross-origin credentials; the external server still receives ordinary connection data, including the IP address.'],
        ['9. Policy updates', 'This policy may be updated when website functions or legal requirements change. The current version is always published on this page.'],
      ],
    },
    terms: {
      eyebrow: 'LEGAL INFORMATION',
      title: 'Terms of Use',
      updated: 'Version dated 29 July 2026',
      intro: 'By using the CarCash website, you agree to these terms. The service is intended for preliminary valuation and discussion of a possible vehicle acquisition in Estonia.',
      sections: [
        ['1. Purpose of the service', 'The CarCash service is provided by Osaühing SVENTLI AUTO, registry code 11002829. The website can retrieve some technical details by REG number or VIN code, or accept a manually entered vehicle, and then prepare a request. Submitting the form is a valuation request and does not create an obligation to complete a transaction.'],
        ['2. Preliminary offer', 'Any price or valuation communicated before inspection is preliminary. The final price, payment, handover, collection and other terms are agreed separately after checking condition, documents and ownership.'],
        ['3. User information', 'The user must provide accurate information, have a lawful right to offer the vehicle, and disclose known restrictions, pledges, finance, damage and other circumstances that may affect a transaction.'],
        ['4. REG, VIN and registry data', 'Registry and decoded data is provided for convenience and may be incomplete or outdated. CarCash does not guarantee absolute accuracy and verifies material information before a transaction.'],
        ['5. Acquisition budget', 'An unlimited acquisition budget means there is no predetermined overall limit for considering requests; it does not guarantee acquisition of a particular vehicle or acceptance of a preliminary valuation.'],
        ['6. Request delivery, website chat and external services', 'The server automatically sends the request to two configured recipients through Resend. After the request has been sent successfully, a trilingual automatic confirmation is sent to the e-mail address provided by the user. Website chat messages are sent to CarCash’s private Telegram group; a separate topic is created for each visitor and replies from authorised administrators appear in the same website chat. If an external service does not accept a delivery, the website displays an error.'],
        ['7. Limitation of liability', 'The website is provided as available. CarCash is not liable for temporary technical failures, acts of external providers, or decisions based solely on preliminary website data. These limitations do not apply where liability cannot be excluded by law.'],
        ['8. Intellectual property and law', 'The website design, text and materials are protected by law. Commercial copying without permission is prohibited. Estonian law applies to use of the website; mandatory consumer rights remain unaffected.'],
        ['9. Changes and contact', 'CarCash may update these terms as the service or law changes. The current version is published on this page. Use the contacts below for questions.'],
      ],
    },
  },
}

function LanguageSwitcher({ locale, onChange, className = '' }) {
  return (
    <div className={`language-switcher ${className}`} role="group" aria-label={translate(locale, 'Язык интерфейса')}>
      {['ru', 'et', 'en'].map((language) => (
        <button
          key={language}
          type="button"
          className={locale === language ? 'active' : ''}
          aria-pressed={locale === language}
          onClick={() => onChange(language)}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  )
}

function Logo({ t = (text) => text }) {
  return (
    <a className="logo" href="/" aria-label={t('CarCash — на главную')}>
      <span className="logo-mark" aria-hidden="true">C</span>
      <span>CARCASH</span>
    </a>
  )
}

function SiteLensBadge() {
  return (
    <a
      className="sitelens-badge"
      href="https://sitelens.ee/"
      target="_blank"
      rel="noopener noreferrer"
      title="Website audit with SiteLens"
    >
      <img
        src="https://sitelens.ee/badge-dark.svg"
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
        alt="Checked with SiteLens"
        width="360"
        height="104"
      />
    </a>
  )
}

const METRIKA_ID = 110890578

function loadYandexMetrika() {
  if (document.querySelector(`script[data-yandex-metrika="${METRIKA_ID}"]`)) return

  window.dataLayer = window.dataLayer || []
  window.ym = window.ym || function yandexMetrika() {
    window.ym.a = window.ym.a || []
    window.ym.a.push(arguments)
  }
  window.ym.l = Date.now()

  const script = document.createElement('script')
  script.async = true
  script.src = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`
  script.dataset.yandexMetrika = String(METRIKA_ID)
  document.head.appendChild(script)

  window.ym(METRIKA_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  })
}

function CookieConsent({ t, onAccept, onNecessary }) {
  return (
    <aside className="cookie-consent" role="dialog" aria-modal="false" aria-labelledby="cookie-consent-title">
      <div className="cookie-consent-copy">
        <span className="cookie-consent-icon" aria-hidden="true"><ShieldCheck size={22} /></span>
        <div>
          <h2 id="cookie-consent-title">{t('Файлы cookie и конфиденциальность')}</h2>
          <p>{t('Мы используем необходимые технологии для работы сайта и сохранения выбранного языка. Дополнительные технологии могут использоваться только с вашего согласия.')}</p>
          <a href="/privacy">{t('Подробнее')}</a>
        </div>
      </div>
      <div className="cookie-consent-actions">
        <button className="cookie-consent-necessary" type="button" onClick={onNecessary}>{t('Только необходимые')}</button>
        <button className="button button-primary" type="button" onClick={onAccept}>{t('Принять')}</button>
      </div>
    </aside>
  )
}

function CompanyDetails({ t, variant = 'footer' }) {
  return (
    <section className={`company-details company-details-${variant}`} aria-label={t('Юридические данные')}>
      <span className="company-details-label">{t('Юридические данные')}</span>
      <a href={companyDetails.registryUrl} target="_blank" rel="noopener noreferrer">
        <strong>{companyDetails.name}</strong>
        <ExternalLink size={13} aria-hidden="true" />
      </a>
      <dl>
        <div>
          <dt>{t('Регистрационный код')}</dt>
          <dd>{companyDetails.registryCode}</dd>
        </div>
        <div>
          <dt>{t('Юридический адрес')}</dt>
          <dd><address>{companyDetails.address}</address></dd>
        </div>
      </dl>
    </section>
  )
}

function BackToTop({ t }) {
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    })
  }

  return (
    <button className="back-to-top" type="button" onClick={scrollToTop} aria-label={t('Наверх')} title={t('Наверх')}>
      <ArrowUp size={19} />
    </button>
  )
}

function LegalPage({ type, locale, setLocale, t, config }) {
  const document = legalDocuments[locale]?.[type] || legalDocuments.ru[type]
  const otherType = type === 'privacy' ? 'terms' : 'privacy'

  return (
    <div className="legal-page" id="top">
      <a className="skip-link" href="#legal-content" onClick={(event) => scrollToPageSection(event, 'legal-content', { focus: true })}>{t('Перейти к содержанию')}</a>
      <header className="legal-header">
        <Logo t={t} />
        <div className="legal-header-actions">
          <LanguageSwitcher locale={locale} onChange={setLocale} />
          <a className="legal-home-link" href="/"><ArrowLeft size={17} /> {t('На главную')}</a>
        </div>
      </header>

      <main className="legal-main" id="legal-content" tabIndex="-1">
        <article className="legal-document">
          <header className="legal-document-heading">
            <p>{document.eyebrow}</p>
            <h1>{document.title}</h1>
            <span>{document.updated}</span>
            <div>{document.intro}</div>
          </header>
          <div className="legal-sections">
            {document.sections.map(([heading, text]) => (
              <section key={heading}>
                <h2>{heading}</h2>
                <p>{text}</p>
              </section>
            ))}
          </div>
          <CompanyDetails t={t} variant="legal" />
          <div className="legal-contact-card">
            <span>CARCASH · ESTONIA</span>
            <a href={`mailto:${config.contactEmail}`}>{config.contactEmail}</a>
            <a href={`tel:${config.contactPhone.replace(/\s/g, '')}`}>{config.contactPhone} · 24/7</a>
          </div>
        </article>
      </main>

      <footer className="legal-footer">
        <div>
          <a href={`/${otherType}`}>{t(otherType === 'privacy' ? 'Политика конфиденциальности' : 'Условия использования')}</a>
          <span>© {new Date().getFullYear()} {companyDetails.name} · CarCash</span>
        </div>
        <SiteLensBadge />
        <BackToTop t={t} />
      </footer>
    </div>
  )
}

function SearchPanel({ compact = false, onResult, t }) {
  const [type, setType] = useState('reg')
  const [value, setValue] = useState('')
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState(null)
  const [officialUrl, setOfficialUrl] = useState(null)
  const inputRef = useRef(null)

  const placeholder = type === 'reg'
    ? t('Например, 123ABC')
    : type === 'vin'
      ? t('17-значный VIN-код')
      : t('Например, экскаватор CAT 320')
  const maxLength = type === 'reg' ? 9 : type === 'vin' ? 17 : 80

  function selectType(nextType) {
    setType(nextType)
    setValue('')
    setError(null)
    setOfficialUrl(null)
    requestAnimationFrame(() => inputRef.current?.focus())
  }

  async function handleSubmit(event) {
    event.preventDefault()
    const normalized = type === 'manual' ? value.trim() : value.toUpperCase().replace(/[\s-]+/g, '')
    setValue(normalized)
    setError(null)
    setOfficialUrl(null)

    if (!normalized) {
      setError(type === 'reg' ? t('Введите регистрационный номер.') : type === 'vin' ? t('Введите VIN-код.') : t('Опишите технику.'))
      inputRef.current?.focus()
      return
    }

    if (type === 'manual') {
      setStatus('success')
      onResult({
        vehicle: { description: normalized },
        source: 'Добавлено вручную',
        registryVerified: false,
        manual: true,
      })
      return
    }

    setStatus('loading')

    try {
      const response = await fetch('/api/vehicle/search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type, value: normalized }),
      })
      const payload = await response.json()

      if (!response.ok) {
        setError(payload.error || t('Не удалось выполнить поиск.'))
        setOfficialUrl(payload.officialUrl || null)
        setStatus('error')
        return
      }

      setStatus('success')
      onResult(payload)
    } catch {
      setError(t('Нет связи с сервером. Проверьте подключение и попробуйте снова.'))
      setStatus('error')
    }
  }

  return (
    <div className={`lookup-card ${compact ? 'lookup-card-compact' : ''}`}>
      {!compact && (
        <div className="lookup-heading">
          <span className="lookup-heading-index" aria-hidden="true">01</span>
          <div className="lookup-heading-copy">
            <span className="eyebrow eyebrow-dark"><Search size={14} /> {t('ПРОВЕРКА ТЕХНИКИ')}</span>
            <h2>{t('Найдём данные за минуту')}</h2>
            <p>{t('REG, VIN или описание — выберите удобный способ идентификации.')}</p>
          </div>
          <div className="lookup-assurance">
            <span className="registry-note"><ShieldCheck size={17} /> {t('Данные защищены')}</span>
            <span className="lookup-domain">carcash.ee · Estonia</span>
          </div>
        </div>
      )}

      <div className="search-tabs" role="tablist" aria-label={t('Тип поиска')}>
        <button
          type="button"
          role="tab"
          aria-selected={type === 'reg'}
          className={type === 'reg' ? 'active' : ''}
          onClick={() => selectType('reg')}
        >
          {t('REG номер')}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={type === 'vin'}
          className={type === 'vin' ? 'active' : ''}
          onClick={() => selectType('vin')}
        >
          {t('VIN-код')}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={type === 'manual'}
          className={type === 'manual' ? 'active' : ''}
          onClick={() => selectType('manual')}
        >
          {t('Без REG / VIN')}
        </button>
      </div>

      <form className="lookup-form" onSubmit={handleSubmit} noValidate>
        <label className="sr-only" htmlFor={compact ? 'compact-vehicle-id' : 'vehicle-id'}>
          {type === 'reg' ? t('Регистрационный номер') : type === 'vin' ? t('VIN-код') : t('Описание техники')}
        </label>
        <div className={`lookup-input-wrap ${type === 'manual' ? 'lookup-input-manual' : ''}`}>
          <span className="country-code" aria-hidden="true">{type === 'manual' ? 'TYPE' : 'EST'}</span>
          <input
            ref={inputRef}
            id={compact ? 'compact-vehicle-id' : 'vehicle-id'}
            name="vehicle-id"
            value={value}
            onChange={(event) => setValue(type === 'manual' ? event.target.value : event.target.value.toUpperCase())}
            placeholder={placeholder}
            maxLength={maxLength}
            autoComplete="off"
            autoCapitalize={type === 'manual' ? 'sentences' : 'characters'}
            spellCheck="false"
            inputMode="text"
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'lookup-error' : undefined}
          />
        </div>
        <button className="button button-primary lookup-button" type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? <LoaderCircle className="spin" size={21} /> : <Search size={20} />}
          <span>{status === 'loading' ? t('Ищем…') : type === 'manual' ? t('Добавить технику') : t('Найти технику')}</span>
        </button>
      </form>

      {error && (
        <div className="lookup-error" id="lookup-error" role="alert">
          <span>{error}</span>
          {officialUrl && (
            <a href={officialUrl} target="_blank" rel="noreferrer">
              {t('Проверить на Transpordiamet')} <ExternalLink size={14} />
            </a>
          )}
        </div>
      )}

    </div>
  )
}

const quickOfferText = {
  ru: {
    eyebrow: 'ПРЯМАЯ ЗАЯВКА',
    title: 'Получить предложение',
    description: 'Укажите REG или VIN и оставьте контактные данные. Мы изучим технику и свяжемся с вами лично.',
    choose: 'Выберите идентификатор',
    reg: 'REG номер',
    vin: 'VIN-код',
    identifier: 'REG номер *',
    regPlaceholder: 'Например, 123ABC',
    vinPlaceholder: '17-значный VIN-код',
    name: 'Ваше имя *',
    namePlaceholder: 'Как к вам обращаться',
    contact: 'Телефон или e-mail *',
    contactPlaceholder: '+372 или e-mail',
    language: 'Язык общения *',
    message: 'Сообщение',
    messagePlaceholder: 'Состояние техники и удобное время для связи',
    submit: 'Отправить заявку',
    sending: 'Отправляем заявку…',
    sent: 'Заявка отправлена',
    invalidReg: 'Введите корректный REG номер: от 2 до 9 букв или цифр.',
    invalidVin: 'Введите корректный VIN-код из 17 символов.',
    required: 'Заполните имя, контакт, язык общения и подтвердите согласие.',
    success: 'Спасибо. Заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.',
    successEmail: 'Спасибо. Заявка успешно отправлена. Подтверждение направлено на указанный e-mail.',
    error: 'Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.',
    notConfigured: 'Сервис отправки ещё не настроен. Свяжитесь с нами по телефону или e-mail.',
    secure: 'Заявка отправляется автоматически и безопасно.',
    protected: 'Данные защищены',
  },
  et: {
    eyebrow: 'OTSETAOTLUS',
    title: 'Saage pakkumine',
    description: 'Sisestage REG-number või VIN-kood ja kontaktandmed. Tutvume tehnikaga ning võtame teiega isiklikult ühendust.',
    choose: 'Valige identifikaator',
    reg: 'REG-number',
    vin: 'VIN-kood',
    identifier: 'REG-number *',
    regPlaceholder: 'Näiteks 123ABC',
    vinPlaceholder: '17-kohaline VIN-kood',
    name: 'Teie nimi *',
    namePlaceholder: 'Kuidas teie poole pöörduda?',
    contact: 'Telefon või e-post *',
    contactPlaceholder: '+372 või e-post',
    language: 'Suhtluskeel *',
    message: 'Sõnum',
    messagePlaceholder: 'Tehnika seisukord ja sobiv ühenduse võtmise aeg',
    submit: 'Saada taotlus',
    sending: 'Saadame taotlust…',
    sent: 'Taotlus on saadetud',
    invalidReg: 'Sisestage korrektne REG-number: 2 kuni 9 tähte või numbrit.',
    invalidVin: 'Sisestage korrektne 17-kohaline VIN-kood.',
    required: 'Sisestage nimi, kontakt ja suhtluskeel ning kinnitage nõusolek.',
    success: 'Aitäh. Teie taotlus on edukalt saadetud. Võtame teiega peagi ühendust.',
    successEmail: 'Aitäh. Teie taotlus on edukalt saadetud. Kinnitus saadeti sisestatud e-posti aadressile.',
    error: 'Taotluse saatmine ebaõnnestus. Proovige uuesti või võtke meiega otse ühendust.',
    notConfigured: 'Saatmisteenus ei ole veel seadistatud. Võtke meiega ühendust telefoni või e-posti teel.',
    secure: 'Taotlus saadetakse automaatselt ja turvaliselt.',
    protected: 'Andmed on kaitstud',
  },
  en: {
    eyebrow: 'DIRECT REQUEST',
    title: 'Get an offer',
    description: 'Enter a REG number or VIN and your contact details. We will review the vehicle and contact you personally.',
    choose: 'Choose an identifier',
    reg: 'REG number',
    vin: 'VIN code',
    identifier: 'REG number *',
    regPlaceholder: 'For example, 123ABC',
    vinPlaceholder: '17-character VIN code',
    name: 'Your name *',
    namePlaceholder: 'How should we address you?',
    contact: 'Phone or e-mail *',
    contactPlaceholder: '+372 or e-mail',
    language: 'Contact language *',
    message: 'Message',
    messagePlaceholder: 'Vehicle condition and a convenient time to contact you',
    submit: 'Send request',
    sending: 'Sending request…',
    sent: 'Request sent',
    invalidReg: 'Enter a valid REG number containing 2 to 9 letters or digits.',
    invalidVin: 'Enter a valid 17-character VIN code.',
    required: 'Enter your name, contact and language, then confirm your consent.',
    success: 'Thank you. Your request has been sent successfully. We will contact you shortly.',
    successEmail: 'Thank you. Your request has been sent successfully. A confirmation has been sent to the e-mail address provided.',
    error: 'The request could not be sent. Please try again or contact us directly.',
    notConfigured: 'The delivery service is not configured yet. Please contact us by phone or e-mail.',
    secure: 'Your request is sent automatically and securely.',
    protected: 'Your data is protected',
  },
}

function QuickOfferPanel({ locale, t }) {
  const copy = quickOfferText[locale] || quickOfferText.ru
  const preferredLanguage = locale === 'et' ? 'Eesti' : locale === 'en' ? 'English' : 'Русский'
  const [identifierType, setIdentifierType] = useState('reg')
  const [identifier, setIdentifier] = useState('')
  const [form, setForm] = useState({
    name: '',
    contact: '',
    language: preferredLanguage,
    message: '',
    consent: false,
  })
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const requestIdRef = useRef('')

  useEffect(() => {
    setForm((current) => ({ ...current, language: preferredLanguage }))
  }, [preferredLanguage])

  function clearStatus() {
    setFormError('')
    setFormSuccess('')
    requestIdRef.current = ''
  }

  function selectIdentifierType(nextType) {
    setIdentifierType(nextType)
    setIdentifier('')
    clearStatus()
  }

  function changeIdentifier(event) {
    setIdentifier(event.target.value.toUpperCase())
    clearStatus()
  }

  function changeField(event) {
    const { name, value, type, checked } = event.target
    setForm((current) => ({ ...current, [name]: type === 'checkbox' ? checked : value }))
    clearStatus()
  }

  async function handleSubmit(event) {
    event.preventDefault()
    const normalizedIdentifier = identifier.toUpperCase().replace(/[\s-]+/g, '')
    setIdentifier(normalizedIdentifier)
    setFormError('')
    setFormSuccess('')

    const identifierIsValid = identifierType === 'reg'
      ? /^[A-Z0-9]{2,9}$/.test(normalizedIdentifier)
      : /^[A-HJ-NPR-Z0-9]{17}$/.test(normalizedIdentifier)

    if (!identifierIsValid) {
      setFormError(identifierType === 'reg' ? copy.invalidReg : copy.invalidVin)
      return
    }

    if (!form.name.trim() || !form.contact.trim() || !form.language || !form.consent) {
      setFormError(copy.required)
      return
    }

    if (!requestIdRef.current) {
      requestIdRef.current = window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2)
    }

    setIsSubmitting(true)

    try {
      const vehicle = identifierType === 'reg'
        ? { registrationNumber: normalizedIdentifier }
        : { vin: normalizedIdentifier }

      const response = await fetch('/api/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          contact: form.contact,
          language: form.language,
          message: form.message,
          consent: form.consent,
          vehicle,
          source: 'Прямая форма «Получить предложение»',
          requestId: requestIdRef.current,
        }),
      })
      const payload = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(payload.code === 'DELIVERY_NOT_CONFIGURED' ? copy.notConfigured : copy.error)
      }

      setFormSuccess(payload.delivery?.confirmationEmail ? copy.successEmail : copy.success)
    } catch (error) {
      setFormError(error.message || copy.error)
    } finally {
      setIsSubmitting(false)
    }
  }

  const identifierLabel = identifierType === 'reg' ? copy.identifier : copy.vin + ' *'

  return (
    <div className="lookup-card quick-offer-card">
      <div className="lookup-heading quick-offer-heading">
        <span className="lookup-heading-index" aria-hidden="true">01</span>
        <div className="lookup-heading-copy">
          <span className="eyebrow eyebrow-dark"><SendHorizontal size={14} /> {copy.eyebrow}</span>
          <h2>{copy.title}</h2>
          <p>{copy.description}</p>
        </div>
        <div className="lookup-assurance">
          <span className="registry-note"><ShieldCheck size={17} /> {copy.protected}</span>
          <span className="lookup-domain">carcash.ee · Estonia</span>
        </div>
      </div>

      <form className="quick-offer-form" onSubmit={handleSubmit} noValidate>
        <div className="quick-offer-type-row">
          <span>{copy.choose}</span>
          <div className="search-tabs quick-offer-tabs" role="tablist" aria-label={copy.choose}>
            <button type="button" role="tab" aria-selected={identifierType === 'reg'} className={identifierType === 'reg' ? 'active' : ''} onClick={() => selectIdentifierType('reg')}>
              {copy.reg}
            </button>
            <button type="button" role="tab" aria-selected={identifierType === 'vin'} className={identifierType === 'vin' ? 'active' : ''} onClick={() => selectIdentifierType('vin')}>
              {copy.vin}
            </button>
          </div>
        </div>

        <div className="quick-offer-grid">
          <label className="quick-offer-field quick-offer-identifier">
            <span>{identifierLabel}</span>
            <div className="quick-offer-control quick-offer-identifier-control">
              <b aria-hidden="true">EST</b>
              <input
                name="identifier"
                value={identifier}
                onChange={changeIdentifier}
                placeholder={identifierType === 'reg' ? copy.regPlaceholder : copy.vinPlaceholder}
                maxLength={identifierType === 'reg' ? 9 : 17}
                autoComplete="off"
                autoCapitalize="characters"
                spellCheck="false"
                aria-invalid={Boolean(formError) && !identifier}
              />
            </div>
          </label>

          <label className="quick-offer-field">
            <span>{copy.name}</span>
            <input name="name" value={form.name} onChange={changeField} placeholder={copy.namePlaceholder} autoComplete="name" />
          </label>

          <label className="quick-offer-field">
            <span>{copy.contact}</span>
            <input name="contact" value={form.contact} onChange={changeField} placeholder={copy.contactPlaceholder} autoComplete="email" />
          </label>

          <label className="quick-offer-field">
            <span>{copy.language}</span>
            <div className="quick-offer-select">
              <Languages size={18} />
              <select name="language" value={form.language} onChange={changeField}>
                <option value="Русский">{t('Русский')}</option>
                <option value="Eesti">Eesti</option>
                <option value="English">English</option>
              </select>
              <ChevronDown size={17} />
            </div>
          </label>

          <label className="quick-offer-field quick-offer-message">
            <span>{copy.message}</span>
            <textarea name="message" value={form.message} onChange={changeField} rows="2" maxLength="1200" placeholder={copy.messagePlaceholder} />
          </label>

          <button className="button button-primary quick-offer-submit" type="submit" disabled={isSubmitting || Boolean(formSuccess)}>
            {isSubmitting ? <LoaderCircle className="spin" size={19} /> : formSuccess ? <Check size={19} /> : <Send size={19} />}
            <span>{isSubmitting ? copy.sending : formSuccess ? copy.sent : copy.submit}</span>
            {!isSubmitting && !formSuccess && <ArrowUpRight size={18} />}
          </button>
        </div>

        <div className="quick-offer-footer">
          <label className="quick-offer-consent">
            <input type="checkbox" name="consent" checked={form.consent} onChange={changeField} />
            <span className="custom-check"><Check size={14} /></span>
            <span>{t('Согласен на обработку указанных данных для подготовки предложения.')}</span>
          </label>
          <p><ShieldCheck size={14} /> {copy.secure}</p>
        </div>

        {formError && <p className="quick-offer-error" role="alert">{formError}</p>}
        {formSuccess && <p className="quick-offer-success" role="status"><Check size={17} /> {formSuccess}</p>}
      </form>
    </div>
  )
}
function VehicleResult({ result, onReset, t }) {
  const [form, setForm] = useState({
    name: '',
    contact: '',
    language: '',
    message: '',
    consent: false,
  })
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const requestIdRef = useRef('')
  const sectionRef = useRef(null)

  useEffect(() => {
    sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  const fields = useMemo(
    () => vehicleFields.filter(([key]) => result.vehicle?.[key]),
    [result.vehicle],
  )

  const title = result.vehicle.description
    || [result.vehicle.make, result.vehicle.model].filter(Boolean).join(' ')
    || t('Найденная техника')

  function changeField(event) {
    const { name, value, type, checked } = event.target
    setForm((current) => ({ ...current, [name]: type === 'checkbox' ? checked : value }))
    setFormError('')
    setFormSuccess('')
  }

  async function handleSubmit(event) {
    event.preventDefault()

    if (!form.name.trim() || !form.contact.trim() || !form.language || !form.consent) {
      setFormError(t('Заполните имя, контакт, язык общения и подтвердите согласие.'))
      return
    }

    setIsSubmitting(true)
    setFormError('')
    setFormSuccess('')

    if (!requestIdRef.current) {
      requestIdRef.current = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`
    }

    try {
      const response = await fetch('/api/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          contact: form.contact,
          language: form.language,
          message: form.message,
          consent: form.consent,
          vehicle: result.vehicle,
          source: result.source,
          requestId: requestIdRef.current,
        }),
      })
      const payload = await response.json().catch(() => ({}))

      if (!response.ok) {
        if (payload.code === 'DELIVERY_NOT_CONFIGURED') {
          throw new Error(t('Сервис отправки ещё не настроен. Свяжитесь с нами по телефону или e-mail.'))
        }
        throw new Error(t('Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.'))
      }

      setFormSuccess(t(payload.delivery?.confirmationEmail
        ? 'Спасибо. Заявка успешно отправлена. Подтверждение направлено на указанный e-mail.'
        : 'Спасибо. Заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.'))
    } catch (error) {
      setFormError(error.message || t('Не удалось отправить заявку. Попробуйте ещё раз или свяжитесь с нами напрямую.'))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="result-section section" ref={sectionRef} aria-labelledby="result-title">
      <div className="container">
        <div className="result-banner">
          <div className="result-success-icon"><Check size={28} strokeWidth={3} /></div>
          <div>
            <span>{t(result.manual ? 'ТЕХНИКА ДОБАВЛЕНА' : 'ТЕХНИКА НАЙДЕНА')}</span>
            <h2 id="result-title">{title}</h2>
          </div>
          <button className="text-button" type="button" onClick={onReset}>{t('Новый поиск')} <ArrowRight size={17} /></button>
        </div>

        <div className="result-layout">
          <article className="vehicle-details-card">
            <div className="vehicle-card-top">
              <div>
                <p className="section-kicker">{t('ДАННЫЕ ТЕХНИКИ')}</p>
                <h3>{title}</h3>
              </div>
              <div className="vehicle-source">
                <BadgeCheck size={18} />
                <span>{t(result.manual ? 'Добавлено вручную' : result.registryVerified ? 'Данные реестра' : 'VIN расшифрован')}</span>
              </div>
            </div>

            {!result.registryVerified && !result.manual && (
              <div className="vin-notice">
                {t('VIN успешно расшифрован. Статус регистрации в Эстонии появится после подключения реестрового API.')}
              </div>
            )}

            {result.manual && (
              <div className="vin-notice manual-notice">
                {t('Техника добавлена без REG и VIN. Уточните состояние и другие данные в сообщении.')}
              </div>
            )}

            <dl className="vehicle-data-grid">
              {fields.map(([key, label, suffix = '']) => (
                <div key={key} className={key === 'vin' || key === 'registrationNumber' ? 'data-highlight' : ''}>
                  <dt>{t(label)}</dt>
                  <dd>{result.vehicle[key]}{suffix}</dd>
                </div>
              ))}
            </dl>

            <p className="source-line">{t('Источник:')} {t(result.source)}</p>
          </article>

          <form className="offer-form-card" onSubmit={handleSubmit} noValidate>
            <div className="offer-form-heading">
              <span className="step-pill">{t('ПЕРСОНАЛЬНАЯ ОЦЕНКА')}</span>
              <h3>{t('Получить частное предложение')}</h3>
              <p>{t('Мы изучим технику и свяжемся с вами лично.')}</p>
            </div>

            <div className="form-grid">
              <label>
                <span>{t('Ваше имя *')}</span>
                <input name="name" value={form.name} onChange={changeField} placeholder={t('Как к вам обращаться')} autoComplete="name" />
              </label>
              <label>
                <span>{t('Телефон или e-mail *')}</span>
                <input name="contact" value={form.contact} onChange={changeField} placeholder={t('+372 или e-mail')} autoComplete="email" />
              </label>

              <label>
                <span>{t('Язык общения *')}</span>
                <div className="select-wrap">
                  <Languages size={19} />
                  <select name="language" value={form.language} onChange={changeField}>
                    <option value="" disabled>{t('Выберите язык')}</option>
                    <option value="Русский">{t('Русский')}</option>
                    <option value="Eesti">Eesti</option>
                    <option value="English">English</option>
                  </select>
                  <ChevronDown size={18} />
                </div>
              </label>
              <label className="form-span-2">
                <span>{t('Сообщение')}</span>
                <textarea name="message" value={form.message} onChange={changeField} rows="4" maxLength="1200" placeholder={t('Опишите состояние техники и удобное время для связи')} />
              </label>
            </div>

            <label className="consent-label">
              <input type="checkbox" name="consent" checked={form.consent} onChange={changeField} />
              <span className="custom-check"><Check size={14} /></span>
              <span>{t('Согласен на обработку указанных данных для подготовки предложения.')}</span>
            </label>

            {formError && <p className="form-error" role="alert">{formError}</p>}
            {formSuccess && <p className="form-success" role="status"><Check size={17} /> {formSuccess}</p>}

            <button className="button button-primary button-wide" type="submit" disabled={isSubmitting || Boolean(formSuccess)}>
              {isSubmitting ? <LoaderCircle className="spin" size={19} /> : formSuccess ? <Check size={19} /> : <Send size={19} />}
              {t(isSubmitting
                ? 'Отправляем заявку…'
                : formSuccess
                  ? 'Заявка отправлена'
                  : 'Запросить персональную оценку')}
            </button>
            <p className="delivery-note"><ShieldCheck size={14} /> {t('Заявка отправляется автоматически и безопасно.')}</p>
          </form>
        </div>
      </div>
    </section>
  )
}

function createChatSessionId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID()
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
}

function SiteChat({ configured, contactEmail, locale, t }) {
  const [sessionId, setSessionId] = useState(() => {
    try {
      const storedId = window.localStorage.getItem('carcash-chat-session-id')
      const id = /^[a-zA-Z0-9_-]{20,100}$/.test(storedId || '')
        ? storedId
        : createChatSessionId()
      window.localStorage.setItem('carcash-chat-session-id', id)
      return id
    } catch {
      return createChatSessionId()
    }
  })
  const [initialProfile] = useState(() => {
    try {
      const stored = JSON.parse(window.localStorage.getItem('carcash-chat-profile') || '{}')
      return {
        name: String(stored?.name || '').slice(0, 80),
        contact: String(stored?.contact || '').slice(0, 160),
      }
    } catch {
      return { name: '', contact: '' }
    }
  })
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState([])
  const [name, setName] = useState(initialProfile.name)
  const [contact, setContact] = useState(initialProfile.contact)
  const [draft, setDraft] = useState('')
  const [sending, setSending] = useState(false)
  const [error, setError] = useState('')
  const [closed, setClosed] = useState(false)
  const [profileSaved, setProfileSaved] = useState(Boolean(initialProfile.name))
  const pollingRef = useRef(false)
  const messagesEndRef = useRef(null)

  const loadMessages = async () => {
    if (pollingRef.current) return
    pollingRef.current = true
    try {
      const response = await fetch(`/api/chat/messages?sessionId=${encodeURIComponent(sessionId)}`, {
        headers: { Accept: 'application/json' },
      })
      if (!response.ok) return
      const payload = await response.json()
      if (Array.isArray(payload.messages)) setMessages(payload.messages)
      setClosed(Boolean(payload.closed))
    } catch {
      // The next poll will retry silently.
    } finally {
      pollingRef.current = false
    }
  }

  useEffect(() => {
    if (!open) return undefined
    loadMessages()
    const timer = window.setInterval(loadMessages, 4000)
    return () => window.clearInterval(timer)
  }, [open, sessionId])

  useEffect(() => {
    if (!open) return
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [messages, open])

  const submitMessage = async (event) => {
    event.preventDefault()
    const cleanName = name.trim()
    const cleanMessage = draft.trim()
    if (closed || (!profileSaved && !cleanName) || !cleanMessage || sending) return

    setSending(true)
    setError('')
    try {
      const response = await fetch('/api/chat/messages', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sessionId,
          name: cleanName,
          contact: contact.trim(),
          message: cleanMessage,
        }),
      })
      const payload = await response.json().catch(() => ({}))
      if (response.status === 409 && payload.code === 'CHAT_CLOSED') {
        if (Array.isArray(payload.messages)) setMessages(payload.messages)
        setClosed(true)
        return
      }
      if (!response.ok) throw new Error(payload.error || 'CHAT_DELIVERY_FAILED')

      setMessages(Array.isArray(payload.messages) ? payload.messages : messages)
      setClosed(false)
      setDraft('')
      setProfileSaved(true)
      try {
        window.localStorage.setItem('carcash-chat-profile', JSON.stringify({
          name: cleanName,
          contact: contact.trim(),
        }))
      } catch {
        // The current chat remains usable without persistent browser storage.
      }
    } catch {
      setError(t('Не удалось отправить сообщение. Попробуйте ещё раз.'))
    } finally {
      setSending(false)
    }
  }

  const startNewConversation = () => {
    const nextSessionId = createChatSessionId()
    setSessionId(nextSessionId)
    setMessages([])
    setClosed(false)
    setError('')
    try {
      window.localStorage.setItem('carcash-chat-session-id', nextSessionId)
    } catch {
      // The new conversation remains usable for the current page.
    }
  }

  const dateLocale = locale === 'et' ? 'et-EE' : locale === 'en' ? 'en-GB' : 'ru-RU'
  const hasStarted = profileSaved || messages.length > 0

  return (
    <div className={`site-chat${open ? ' is-open' : ''}`}>
      {open && (
        <section className="site-chat-panel" role="dialog" aria-modal="false" aria-labelledby="site-chat-title">
          <header className="site-chat-header">
            <div>
              <span className={`site-chat-status${configured && !closed ? '' : ' is-offline'}`} aria-hidden="true"></span>
              <div>
                <h2 id="site-chat-title">{t('Чат с CarCash')}</h2>
                <p>{t(closed ? 'Диалог завершён' : 'Обычно отвечаем в рабочее время')}</p>
              </div>
            </div>
            <button type="button" onClick={() => setOpen(false)} aria-label={t('Закрыть чат')}>
              <X size={20} />
            </button>
          </header>

          <div className="site-chat-messages" aria-live="polite">
            {messages.length === 0 && !closed && (
              <div className="site-chat-welcome">
                <span><MessageCircle size={22} /></span>
                <h3>{t('Напишите нам — ответ появится здесь.')}</h3>
              </div>
            )}
            {messages.map((message) => (
              <article
                className={`site-chat-message site-chat-message-${message.direction}`}
                key={message.id}
              >
                <strong>{t(message.direction === 'admin' ? 'Команда CarCash' : 'Вы')}</strong>
                <p>{message.text}</p>
                <time dateTime={message.createdAt}>
                  {new Intl.DateTimeFormat(dateLocale, {
                    hour: '2-digit',
                    minute: '2-digit',
                  }).format(new Date(message.createdAt))}
                </time>
              </article>
            ))}
            <div ref={messagesEndRef}></div>
          </div>

          {configured && closed ? (
            <div className="site-chat-closed" role="status">
              <span><Check size={20} /></span>
              <div>
                <h3>{t('Диалог завершён')}</h3>
                <p>{t('Этот диалог был закрыт. Если хотите продолжить, начните новый.')}</p>
              </div>
              <button type="button" onClick={startNewConversation}>
                {t('Начать новый диалог')} <ArrowRight size={16} />
              </button>
            </div>
          ) : configured ? (
          <form className="site-chat-form" onSubmit={submitMessage}>
            {!hasStarted && (
              <div className="site-chat-profile">
                <label>
                  <span>{t('Ваше имя *')}</span>
                  <input
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    maxLength="80"
                    autoComplete="name"
                    required
                  />
                </label>
                <label>
                  <span>{t('E-mail или телефон')}</span>
                  <input
                    type="text"
                    value={contact}
                    onChange={(event) => setContact(event.target.value)}
                    maxLength="160"
                    autoComplete="email"
                  />
                </label>
              </div>
            )}
            <label className="site-chat-draft">
              <span className="sr-only">{t('Ваше сообщение')}</span>
              <textarea
                value={draft}
                onChange={(event) => setDraft(event.target.value)}
                maxLength="1200"
                rows="3"
                placeholder={t('Напишите сообщение…')}
                required
              />
              <button type="submit" disabled={sending || !draft.trim()} aria-label={t('Отправить сообщение')}>
                {sending ? <LoaderCircle className="spin" size={19} /> : <SendHorizontal size={19} />}
              </button>
            </label>
            {error && <p className="site-chat-error" role="alert">{error}</p>}
            <p className="site-chat-privacy">
              {t('Отправляя сообщение, вы соглашаетесь с обработкой данных согласно')}{' '}
              <a href="/privacy">{t('политике конфиденциальности')}</a>.
            </p>
          </form>
          ) : (
            <div className="site-chat-offline" role="status">
              <p>{t('Чат временно недоступен.')}</p>
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </div>
          )}
        </section>
      )}

      <button
        type="button"
        className="site-chat-launcher"
        onClick={() => setOpen((current) => !current)}
        aria-label={t(open ? 'Закрыть чат' : 'Открыть чат')}
        aria-expanded={open}
      >
        {!open && <span className="site-chat-launcher-label">{t('Напишите нам')}</span>}
        <span className="site-chat-launcher-icon">
          {open ? <X size={27} /> : <MessageCircle size={27} />}
        </span>
        {!open && <span className="site-chat-launcher-dot" aria-hidden="true"></span>}
      </button>
    </div>
  )
}

function App() {
  const [config, setConfig] = useState({
    contactEmail: 'carcashlike@gmail.com',
    contactPhone: '+372 5 526 527',
    chatConfigured: false,
    lookupBlockVariant: 1,
  })
  const [result, setResult] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const [trackingConsent, setTrackingConsent] = useState(() => {
    try {
      const saved = window.localStorage.getItem('carcash-tracking-consent')
      return ['accepted', 'necessary'].includes(saved) ? saved : null
    } catch {
      return null
    }
  })
  const [locale, setLocale] = useState(() => {
    try {
      const saved = window.localStorage.getItem('carcash-locale')
      return ['ru', 'et', 'en'].includes(saved) ? saved : 'ru'
    } catch {
      return 'ru'
    }
  })
  const t = (text) => translate(locale, text)
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/'
  const legalType = pathname === '/privacy' ? 'privacy' : pathname === '/terms' ? 'terms' : null

  useEffect(() => {
    fetch('/api/config')
      .then((response) => response.json())
      .then((payload) => setConfig({ ...payload, contactEmail: 'carcashlike@gmail.com' }))
      .catch(() => {})
  }, [])

  useEffect(() => {
    document.documentElement.lang = locale
    try {
      window.localStorage.setItem('carcash-locale', locale)
    } catch {
      // Language switching still works when storage is unavailable.
    }
  }, [locale])

  useEffect(() => {
    if (trackingConsent === 'accepted') loadYandexMetrika()
  }, [trackingConsent])

  useEffect(() => {
    const canonical = window.document.querySelector('link[rel="canonical"]')
    if (canonical) canonical.setAttribute('href', `https://carcash.ee${pathname === '/' ? '/' : pathname}`)

    if (legalType) {
      const document = legalDocuments[locale]?.[legalType] || legalDocuments.ru[legalType]
      window.document.title = `${document.title} | CarCash`
    }
  }, [legalType, locale, pathname])

  function closeMenu() {
    setMenuOpen(false)
  }

  function scrollFromNavigation(event, sectionId) {
    closeMenu()
    scrollToPageSection(event, sectionId)
  }

  function showResult(payload) {
    setResult(payload)
  }

  function resetSearch() {
    setResult(null)
    requestAnimationFrame(() => document.getElementById('lookup')?.scrollIntoView({ behavior: 'smooth' }))
  }

  function saveTrackingConsent(value) {
    try {
      window.localStorage.setItem('carcash-tracking-consent', value)
    } catch {
      // The choice still applies for the current page when storage is unavailable.
    }
    setTrackingConsent(value)
  }

  const cookieNotice = trackingConsent ? null : (
    <CookieConsent
      t={t}
      onAccept={() => saveTrackingConsent('accepted')}
      onNecessary={() => saveTrackingConsent('necessary')}
    />
  )

  if (legalType) {
    return (
      <>
        <LegalPage type={legalType} locale={locale} setLocale={setLocale} t={t} config={config} />
        <SiteChat configured={config.chatConfigured} contactEmail={config.contactEmail} locale={locale} t={t} />
        {cookieNotice}
      </>
    )
  }

  return (
    <>
      <a className="skip-link" href="#main" onClick={(event) => scrollToPageSection(event, 'main', { focus: true })}>{t('Перейти к содержанию')}</a>
      <header className="site-header" id="top">
        <div className="header-inner header-inner-wide">
          <Logo t={t} />
          <nav className={`main-nav ${menuOpen ? 'open' : ''}`} aria-label={t('Основная навигация')}>
            <a href="#categories" onClick={(event) => scrollFromNavigation(event, 'categories')}>{t('Что покупаем')}</a>
            <a href="#process" onClick={(event) => scrollFromNavigation(event, 'process')}>{t('Как это работает')}</a>
            <a href="#faq" onClick={(event) => scrollFromNavigation(event, 'faq')}>{t('Вопросы')}</a>
            <a className="mobile-contact" href={`tel:${config.contactPhone.replace(/\s/g, '')}`} onClick={closeMenu}>
              <Phone size={18} /> {config.contactPhone} <small>24/7</small>
            </a>
            <LanguageSwitcher className="mobile-language-switcher" locale={locale} onChange={setLocale} />
          </nav>
          <div className="header-actions">
            <LanguageSwitcher className="header-language-switcher" locale={locale} onChange={setLocale} />
            <a className="header-phone" href={`tel:${config.contactPhone.replace(/\s/g, '')}`}>
              <span className="header-phone-icon"><Phone size={16} /></span>
              <span><small>{t('Позвонить нам')} · 24/7</small>{config.contactPhone}</span>
            </a>
            <a className="button button-primary button-small" href="#lookup" onClick={(event) => scrollToPageSection(event, 'lookup')}>{t('Оценить технику')} <ArrowUpRight size={17} /></a>
            <button className="menu-button" type="button" aria-label={t(menuOpen ? 'Закрыть меню' : 'Открыть меню')} aria-expanded={menuOpen} onClick={() => setMenuOpen((current) => !current)}>
              {menuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </header>

      <main id="main" tabIndex="-1">
        <section className="hero section">
          <div className="hero-showcase">
            <img
              className="hero-photo"
              src="/images/hero-fleet-premium-1920.webp"
              srcSet="/images/hero-fleet-premium-1920.webp 1920w, /images/hero-fleet-premium-3840.webp 3840w"
              sizes="100vw"
              style={{ display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, height: '100%' }}
              alt={t('Автомобиль, грузовик, экскаватор, мотоцикл и катер, которые покупает CarCash')}
              width="3840"
              height="1756"
              decoding="async"
              fetchPriority="high"
            />
            <div className="hero-shade" aria-hidden="true"></div>
            <div className="hero-copy">
              <span className="eyebrow eyebrow-on-photo"><MapPin size={14} /> {t('ВЫКУП ТЕХНИКИ · ЭСТОНИЯ')}</span>
              <h1><span>{t('Точная оценка.')}</span><em>{t('Честная сделка.')}</em></h1>
              <p className="hero-lead">{t('Автомобили, коммерческий транспорт и специальная техника. Найдите объект по REG или VIN и получите персональное предложение.')}</p>
              <p className="hero-budget"><span aria-hidden="true"></span>{t('Бюджет на выкуп не ограничен')}</p>
              <div className="hero-actions">
                <a className="button button-primary button-large" href="#lookup" onClick={(event) => scrollToPageSection(event, 'lookup')}>{t('Оценить технику')} <ArrowRight size={19} /></a>
                <div className="hero-contact">
                  <a className="hero-phone-link" href={`tel:${config.contactPhone.replace(/\s/g, '')}`}><Phone size={18} /> {config.contactPhone} <small>24/7</small></a>
                  <a className="hero-email-link" href={`mailto:${config.contactEmail}`}><Mail size={16} /> {config.contactEmail}</a>
                </div>
              </div>
            </div>
          </div>

          <div className="lookup-container" id="lookup">
            {config.lookupBlockVariant === 2
              ? <SearchPanel onResult={showResult} t={t} />
              : <QuickOfferPanel locale={locale} t={t} />}
          </div>
        </section>

        {config.lookupBlockVariant === 2 && result && <VehicleResult result={result} onReset={resetSearch} t={t} />}

        <section className="categories-section section" id="categories">
          <div className="container">
            <div className="section-heading section-heading-row">
              <div>
                <p className="section-kicker">{t('ЧТО МОЖНО ПРЕДЛОЖИТЬ')}</p>
                <h2>{t('Выберите свою')}<br />{t('категорию техники')}</h2>
              </div>
              <p>{t('Покупаем исправную и повреждённую технику у частных лиц и компаний. Каждое предложение оцениваем индивидуально.')}</p>
            </div>
            <div className="photo-category-grid">
              <article className="photo-category-card photo-category-cars">
                <img
                  src="/images/category-cars-premium-1440.webp"
                  srcSet="/images/category-cars-premium-1440.webp 1440w, /images/category-cars-premium-2880.webp 2880w"
                  sizes="(max-width: 900px) 100vw, 42vw"
                  style={{ display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, height: '100%' }}
                  alt={t('Автомобили')}
                  width="2880"
                  height="1440"
                  loading="lazy"
                  decoding="async"
                />
                <div className="photo-card-shade"></div>
                <div className="photo-card-content">
                  <span className="photo-card-kicker"><CarFront size={18} /> {t('ЛЕГКОВОЙ ТРАНСПОРТ')}</span>
                  <h3>{t('Автомобили')}</h3>
                  <p>{t('Любой возраст, пробег и состояние.')}</p>
                </div>
                <a href="#lookup" aria-label={t('Оценить технику')} onClick={(event) => scrollToPageSection(event, 'lookup')}><ArrowUpRight /></a>
              </article>

              <article className="photo-category-card photo-category-heavy">
                <img
                  src="/images/category-heavy-premium-1440.webp"
                  srcSet="/images/category-heavy-premium-1440.webp 1440w, /images/category-heavy-premium-2880.webp 2880w"
                  sizes="(max-width: 900px) 100vw, 58vw"
                  style={{ display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, height: '100%' }}
                  alt={t('Грузовики и спецтехника')}
                  width="2880"
                  height="1644"
                  loading="lazy"
                  decoding="async"
                />
                <div className="photo-card-shade"></div>
                <div className="photo-card-content">
                  <span className="photo-card-kicker"><Tractor size={18} /> {t('ПРОФЕССИОНАЛЬНАЯ ТЕХНИКА')}</span>
                  <h3>{t('Грузовики и спецтехника')}</h3>
                  <p>{t('Рабочая техника для стройки, леса и логистики.')}</p>
                </div>
                <a href="#lookup" aria-label={t('Оценить технику')} onClick={(event) => scrollToPageSection(event, 'lookup')}><ArrowUpRight /></a>
              </article>

              <article className="photo-category-card photo-category-leisure">
                <img
                  src="/images/category-leisure-premium-1440.webp"
                  srcSet="/images/category-leisure-premium-1440.webp 1440w, /images/category-leisure-premium-2880.webp 2880w"
                  sizes="(max-width: 900px) 100vw, 58vw"
                  style={{ display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, height: '100%' }}
                  alt={t('Мото, ATV и катера')}
                  width="2880"
                  height="1368"
                  loading="lazy"
                  decoding="async"
                />
                <div className="photo-card-shade"></div>
                <div className="photo-card-content">
                  <span className="photo-card-kicker"><Bike size={18} /> {t('ТЕХНИКА ДЛЯ ОТДЫХА')}</span>
                  <h3>{t('Мото, ATV и катера')}</h3>
                  <p>{t('Дорожная, внедорожная и водная техника.')}</p>
                </div>
                <a href="#lookup" aria-label={t('Оценить технику')} onClick={(event) => scrollToPageSection(event, 'lookup')}><ArrowUpRight /></a>
              </article>

              <article className="category-help-card">
                <span className="help-card-icon"><Headphones /></span>
                <div><p>{t('НЕ НАШЛИ КАТЕГОРИЮ?')}</p><h3>{t('Предложите любую технику')}</h3></div>
                <p>{t('Опишите её в сообщении — мы всё равно рассмотрим заявку.')}</p>
                <a className="button button-primary" href="#lookup" onClick={(event) => scrollToPageSection(event, 'lookup')}>{t('Отправить данные')} <ArrowRight size={18} /></a>
              </article>
            </div>
          </div>
        </section>

        <section className="process-section section" id="process">
          <div className="container process-layout">
            <div className="process-intro">
              <p className="section-kicker section-kicker-light">{t('ПРОСТОЙ ПРОЦЕСС')}</p>
              <h2>{t('От номера до предложения — три шага')}</h2>
              <p>{t('Никаких сложных анкет. Сначала находим данные техники, затем уточняем детали и связываемся на удобном языке.')}</p>
              <a className="button button-primary" href="#lookup" onClick={(event) => scrollToPageSection(event, 'lookup')}>{t('Начать оценку')} <ArrowRight size={19} /></a>
            </div>
            <ol className="process-list">
              <li>
                <span className="process-number">01</span>
                <div><h3>{t('Найдите технику')}</h3><p>{t('Введите REG, VIN или добавьте технику без номера.')}</p></div>
              </li>
              <li>
                <span className="process-number">02</span>
                <div><h3>{t('Укажите контакты')}</h3><p>{t('Добавьте контакты и язык общения.')}</p></div>
              </li>
              <li>
                <span className="process-number">03</span>
                <div><h3>{t('Получите предложение')}</h3><p>{t('Мы оценим технику и обсудим удобную сделку.')}</p></div>
              </li>
            </ol>
          </div>
        </section>

        <section className="trust-section section">
          <div className="container trust-grid">
            <article className="trust-main-card">
              <span className="eyebrow eyebrow-dark">{t('ПОДХОД CARCASH')}</span>
              <h2>{t('Сначала факты.')}<br />{t('Затем предложение.')}</h2>
              <p>{t('Мы заранее изучаем регистрационные данные и ваше описание техники. Поэтому разговор начинается с конкретики, а окончательные условия согласуются только после проверки состояния.')}</p>
              <div className="trust-signature"><span>{t('Персональная оценка')}</span><span>{t('Без обязательств')}</span></div>
            </article>
            <div className="trust-points">
              <article><ShieldCheck /><div><h3>{t('Без обязательств')}</h3><p>{t('Отправка заявки не обязывает вас продавать технику.')}</p></div></article>
              <article><Clock3 /><div><h3>{t('Ценим ваше время')}</h3><p>{t('Данные подставляются автоматически и безопасно отправляются нашей команде.')}</p></div></article>
              <article><Languages /><div><h3>RU · ET · EN</h3><p>{t('Выберите удобный язык до отправки заявки.')}</p></div></article>
            </div>
          </div>
        </section>

        <section className="faq-section section" id="faq">
          <div className="container faq-layout">
            <div className="faq-intro">
              <p className="section-kicker">{t('ВОПРОСЫ И ОТВЕТЫ')}</p>
              <h2>{t('Коротко о главном')}</h2>
              <p>{t('Не нашли ответ? Напишите нам напрямую — разберём ваше предложение индивидуально.')}</p>
              <a href={`mailto:${config.contactEmail}`} className="text-link"><Mail size={17} /> {config.contactEmail}</a>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => (
                <details key={item.question} open={index === 0}>
                  <summary><span>{t(item.question)}</span><span className="faq-toggle">+</span></summary>
                  <p>{t(item.answer)}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="cta-section" id="final-offer">
          <div className="container cta-card">
            <div className="cta-copy">
              <p className="section-kicker section-kicker-light">{t('ЕСТЬ ТЕХНИКА НА ПРОДАЖУ?')}</p>
              <h2><span>{t('Начнём с точной оценки')}</span><br /><em>{t('вашей техники.')}</em></h2>
              <p className="cta-lead">{t('Предварительная оценка без обязательств. Работаем по всей Эстонии и рассматриваем любую технику.')}</p>
            </div>
            <div className="cta-action">
              <a className="button button-primary button-large" href="#lookup" onClick={(event) => scrollToPageSection(event, 'lookup')}><span className="cta-button-label">{t('Получить оценку')}</span><ArrowUpRight size={21} /></a>
              <span><Languages size={16} /> {t('RU · ET · EN — ответим на удобном языке')}</span>
            </div>
            <div className="cta-facts">
              <span><ShieldCheck size={16} /> {t('Без обязательств')}</span>
              <span><MapPin size={16} /> {t('Вся Эстония')}</span>
              <span><BadgeCheck size={16} /> {t('Бюджет на выкуп не ограничен')}</span>
            </div>
          </div>
        </section>
      </main>

      <footer className="site-footer" id="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <Logo t={t} />
            <p>{t('Персональная оценка и выкуп техники по всей Эстонии.')}</p>
            <CompanyDetails t={t} />
            <SiteLensBadge />
          </div>
          <div>
            <h3>{t('Навигация')}</h3>
            <a href="#categories" onClick={(event) => scrollToPageSection(event, 'categories')}>{t('Что покупаем')}</a>
            <a href="#process" onClick={(event) => scrollToPageSection(event, 'process')}>{t('Как это работает')}</a>
            <a href="#faq" onClick={(event) => scrollToPageSection(event, 'faq')}>{t('Вопросы')}</a>
          </div>
          <div>
            <h3>{t('Контакты')}</h3>
            <a href={`tel:${config.contactPhone.replace(/\s/g, '')}`}><Phone size={16} /> {config.contactPhone}</a>
            <a href={`mailto:${config.contactEmail}`}><Mail size={16} /> {config.contactEmail}</a>
            <span><Clock3 size={16} /> 24/7</span>
            <span><MapPin size={16} /> {t('Вся Эстония')}</span>
          </div>
          <div>
            <h3>{t('Языки')}</h3>
            <div className="footer-languages" role="group" aria-label={t('Язык интерфейса')}>
              {[
                ['ru', 'Русский'],
                ['et', 'Eesti'],
                ['en', 'English'],
              ].map(([language, label]) => (
                <button
                  key={language}
                  type="button"
                  className={locale === language ? 'active' : ''}
                  aria-pressed={locale === language}
                  onClick={() => setLocale(language)}
                >
                  <span>{label}</span>
                  <span className="footer-language-code" aria-hidden="true">{language.toUpperCase()}</span>
                </button>
              ))}
            </div>
          </div>
          <div>
            <h3>{t('Документы')}</h3>
            <a href="/privacy">{t('Политика конфиденциальности')}</a>
            <a href="/terms">{t('Условия использования')}</a>
          </div>
        </div>
        <div className="container footer-bottom">
          <div>
            <span>© {new Date().getFullYear()} {companyDetails.name} · CarCash. {t('Все права защищены.')}</span>
            <span>{t('Данные реестра носят информационный характер.')}</span>
          </div>
          <BackToTop t={t} />
        </div>
      </footer>
      <SiteChat configured={config.chatConfigured} contactEmail={config.contactEmail} locale={locale} t={t} />
      {cookieNotice}
    </>
  )
}

export default App
